import React, { useState, useEffect, Fragment, useRef } from "react";
import ImageZoom from "../../../components/ImageZoom";
import getOutletGroupDetails from "../../../actions/outlet/getOutletGroupDetails";
import { Document, Page, pdfjs } from "react-pdf";
import CircleLoader from "../../../components/CircleLoader";
import Slider from "react-slick";
import moment from "moment";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Modal } from "../../../../src/components/Modal";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { FormRow } from "../components/FormRow";
import { DashboardTextBox } from "../components/DashboardTexBox";
import {
  VerticalNavItem,
  VerticalNav,
  PrevArrow,
  NextArrow,
  ContentWrapper,
  Title,
} from "./outlet.styles";
import Loader from "../../../components/Loader";
import {
  black100,
  green300,
  black600,
  black200,
  black300,
  curiousBlue300,
  white,
  black700,
  cinnabar300,
} from "../../../theme/colors";
import { triggerSimpleAjax } from "../../../helpers/httpHelper";
import {
  GET_OUTLET_GROUP,
  GET_OUTLET_GROUP_SAVE,
  IFSC_VERIFICATION,
  PAN_AND_GST_VERIFICATION,
  UPI_VERIFICATION,
  CHECK_DISTRIBUTOR_GST,
  LOCATION_DROPDOWN,
  FILE_UPLOAD_API,
  UPLOAD_DOCUMENT_FILE_API,
  YES_BANK_ACCOUNT_VERIFICATION,
} from "../../../helpers/constants/apiUrl";
import { Button } from "../../../components/Button";
import styled from "styled-components";
import { outletQuestionGroupSaveAction } from "./helper/outletQuestionGroupSaveAction";
import { isRelativeDateValidation } from "../../../utils/CommonFunction";
import _cloneDeep from "lodash/cloneDeep";
import { baseCaption, defaultFont } from "../../../theme/typography";
import { getDayOrNumberSuffix } from "../../../helpers/getDayOrNumbersuffix";
import { WORKFLOW_KEYS } from "../../../helpers/constants/workflowKeys";
import { SelectFilter } from "../components/SelectFilter";
import capitializeFirstChar from "../../../helpers/utils/capitializeFirstChar";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import CloseIcon from "@material-ui/icons/Close";
import { semiBold } from "../../../theme/typeface";
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import triggerNotification from "../../../actions/triggerNotification";
import ReactTooltip from "react-tooltip";
import SkuTableOutlet from "./sku-table-outlet";
import { Dashboard } from "@material-ui/icons";
import ImageIcon from "@material-ui/icons/Image";
import { DASHBOARDROUTES } from "../../../helpers/constants/routes";
import { useHistory } from "react-router-dom";
import CheckBox from "../../../components/ui/CheckBox";
import CollectedBills from "./CollectedBills";
import InvoiceDigitization from "./InvoiceDigitization";
import Snackbar from "@material-ui/core/Snackbar";
import { Paper, Typography, IconButton } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import { Error } from "@material-ui/icons";
import DescriptionIcon from "@material-ui/icons/Description";
import { ConfirmationModal } from "../components/ConfirmationModal";
import { getRetailerRequests } from "../../../actions/creation/getRetailerEditScreen";
import {
  isNextGroupShortcut,
  isPrevGroupShortcut,
  isTotalImageShortcut,
  isSaveShortcut,
  isResetShortcut,
  isValidateShortcut,
  getShortcutLabel,
  isAnyModalOpen,
  focusNextInputField,
  createVerificationChordManager,
} from "./helper/shortcutUtils";
pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
const sliderRef = React.createRef();

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 82%;
`;

const TextWrapper = styled.p`
  ${baseCaption}
  color:${black600};
  margin: 8px 0 0;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  font-family: 'Outfit', 'Inter', sans-serif;
`;

const ModalTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: #1e2e4e;
  margin-top: 0;
  margin-bottom: 24px;
  text-align: left;
`;

const FileDragDropZone = styled.div`
  border: 2px dashed ${props => props.isDragging ? '#3E96C8' : '#DEDEDE'};
  background-color: ${props => props.isDragging ? '#F4F9FC' : '#FFFFFF'};
  border-radius: 8px;
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 24px;
  transition: all 0.2s ease-in-out;
  text-align: center;
  position: relative;
`;

const FileDragText = styled.p`
  font-size: 16px;
  color: #585a5a;
  margin: 0 0 8px 0;
  font-weight: 500;
`;

const FileOrText = styled.p`
  font-size: 14px;
  color: #bcBdbd;
  margin: 0 0 8px 0;
`;

const FileBrowseLink = styled.span`
  font-size: 16px;
  color: #3e96c8;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 12px;
  
  &:hover {
    text-decoration: underline;
  }
`;

const FileSizeText = styled.p`
  font-size: 13px;
  color: #909191;
  margin: 0;
`;

const FileLoaderOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

const FileLoaderText = styled.p`
  font-size: 14px;
  color: #585a5a;
  margin-top: 12px;
  font-weight: 500;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
`;
const VerificationText = styled.div`
  svg {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    vertical-align: middle;
    color: ${(props) => (props.isVerified ? green300 : cinnabar300)};
  }
  margin-top: 3px;
  display: flex;
  flex-direction: row;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const QuestionContainer = styled.div`
  overflow-y: scroll;
  max-height: 600px;
  min-width: 350px;
  padding-bottom: 20px;
`;

const TotalImageCount = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background: #4770c1;
  color: #ffffff;
  padding: ${(props) => (props.clientScreen ? "6px 12px" : "9px 12px")};
  font-weight: 500;
  font-size: ${(props) => (props.clientScreen ? "13px" : "14px")};
  margin-bottom: 30px;
  cursor: pointer;
`;

const getStringListArr = (string) => {
  const hypenSplitArr = [];
  const spaceSplitArr = string.split(" ");
  spaceSplitArr.map((string) => {
    const hypenSplit = string.split("-");
    if (hypenSplit.length > 0) {
      hypenSplitArr.push(...hypenSplit);
    }
  });

  return hypenSplitArr;
};
const getIsKeyInString = (string, key) => {
  let isPresent = false;
  if (string) {
    const stringArr = getStringListArr(string);
    stringArr.map((strVal) => {
      if (strVal.toUpperCase() === key.toUpperCase()) {
        isPresent = true;
      }
    });
  }
  return isPresent;
};

const CensusNetworkFields = ({ value, onChange, disabled, width, locationHierarchy, notificationHandler }) => {
  const levels = ["region", "region", "state", "district", "subdistrict"];
  const levelNames = ["Region", "State", "District", "Subdistrict", "Location"];
  const [sels, setSels] = useState(() => {
    if (locationHierarchy && Object.keys(locationHierarchy).length > 0) {
      const keys = ["region", "state", "district", "sub_district", "location"];
      return keys.map(k => {
        const item = locationHierarchy[k] || (k === "sub_district" ? locationHierarchy.subdistrict : null);
        return item ? { label: item.name || String(item), value: item.id !== undefined ? String(item.id) : String(item) } : null;
      });
    }
    return [null, null, null, null, null];
  });
  const [opts, setOpts] = useState([[], [], [], [], []]);

  const loadOpts = (lvlIdx, parentVal) => {
    const url = `${LOCATION_DROPDOWN}?type=${levels[lvlIdx]}${parentVal ? `&value=${encodeURIComponent(parentVal)}` : ""}`;
    triggerSimpleAjax(url, "GET", {}, (res) => {
      const data = res?.result?.data || res?.result || res;
      const items = (Array.isArray(data) ? data : []).map(x => ({
        label: x.name || x.label || String(x),
        value: x.id !== undefined ? String(x.id) : String(x.value || x)
      }))
        .sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }));
      setOpts(prev => {
        const next = [...prev];
        next[lvlIdx] = items;
        return next;
      });
    });
  };

  const expectedValue = sels.every(x => x !== null) ? sels[4].label : "pls select the reason";
  const expectedValueId = sels.every(x => x !== null) ? sels[4].value : "pls select the reason";

  useEffect(() => {
    loadOpts(0, null);
    if (locationHierarchy && Object.keys(locationHierarchy).length > 0) {
      const keys = ["region", "state", "district", "sub_district", "location"];
      const parsed = keys.map(k => {
        const item = locationHierarchy[k] || (k === "sub_district" ? locationHierarchy.subdistrict : null);
        return item ? { label: item.name || String(item), value: item.id !== undefined ? String(item.id) : String(item) } : null;
      });
      parsed.forEach((x, idx) => {
        if (x && idx < 4) {
          loadOpts(idx + 1, x.value);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (String(value) === String(expectedValue) || String(value) === String(expectedValueId)) return;

    if (value && value !== "pls select the reason") {
      const url = `${LOCATION_DROPDOWN}?type=location&value=${encodeURIComponent(value)}&include_hierarchy=true`;
      triggerSimpleAjax(url, "GET", {}, (res) => {
        const data = res?.result?.data || res?.result || res;
        if (!data) return;
        const keys = ["region", "state", "district", "subdistrict", "location"];
        const parsed = keys.map(k => {
          const item = data[k] || (k === "location" ? { name: value, id: value } : null);
          return item ? { label: item.name || String(item), value: item.id !== undefined ? String(item.id) : String(item) } : null;
        });
        setSels(parsed);
        parsed.forEach((x, idx) => {
          if (x && idx < 4) loadOpts(idx + 1, x.value);
        });
      });
    } else {
      setSels([null, null, null, null, null]);
      setOpts(prev => [prev[0], [], [], [], []]);
    }
  }, [value]);

  const handleChange = (lvlIdx, val) => {
    const nextSels = [...sels];
    nextSels[lvlIdx] = val;
    for (let i = lvlIdx + 1; i < 5; i++) nextSels[i] = null;
    setSels(nextSels);

    setOpts(prev => {
      const next = [...prev];
      for (let i = lvlIdx + 1; i < 5; i++) next[i] = [];
      return next;
    });

    if (val && lvlIdx < 4) {
      loadOpts(lvlIdx + 1, val.value);
    }
    const allFilled = nextSels.every(x => x !== null);
    const nextHierarchy = allFilled ? {
      region: nextSels[0] ? { id: Number(nextSels[0].value) || nextSels[0].value, name: nextSels[0].label } : null,
      state: nextSels[1] ? { id: Number(nextSels[1].value) || nextSels[1].value, name: nextSels[1].label } : null,
      district: nextSels[2] ? { id: Number(nextSels[2].value) || nextSels[2].value, name: nextSels[2].label } : null,
      sub_district: nextSels[3] ? { id: Number(nextSels[3].value) || nextSels[3].value, name: nextSels[3].label } : null,
      location: nextSels[4] ? { id: Number(nextSels[4].value) || nextSels[4].value, name: nextSels[4].label } : null,
    } : null;
    onChange(allFilled ? nextSels[4].value : "pls select the reason", nextHierarchy);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: width || "340px", margin: "8px 0" }}>
      {levelNames.map((name, idx) => {
        const isDisabled = disabled || (idx > 0 && !sels[idx - 1]);
        return (
          <div key={name}>
            <label style={{ fontSize: "12px", color: "#6b7280", display: "block", marginBottom: "3px", fontWeight: 500 }}>{name}</label>
            <div
              onClick={() => {
                if (idx > 0 && !sels[idx - 1] && !disabled && notificationHandler) {
                  notificationHandler({ messageText: `Please select ${levelNames[idx - 1]} first.`, status: "FAILED" });
                }
              }}
              style={{ width: "100%" }}
            >
              <SelectFilter
                props={{
                  placeholder: `Select ${name}`,
                  border: `1px solid ${black200}`,
                  placeholderColor: black700,
                  isDisabled: isDisabled,
                  options: opts[idx],
                  value: sels[idx],
                  onChange: (val) => handleChange(idx, val),
                  width: "100%",
                }}
                customStyles={{ borderRadius: "2px", background: black200 }}
                containerStyles={{ pointerEvents: isDisabled ? "none" : "auto" }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};


const OutletSurvey = ({
  question_groups,
  question_and_answers,
  outletDetails,
  sub_project,
  totalImages = [],
  setSaveClickedData,
  saveClickedData,
  workflow_permission,
  isUpdateActionListAvailable = true,
  workflowStateChanged,
  triggerNotification,
  workflow_state,
  is_hold,
}) => {
  const history = useHistory();
  const [ifscVerificationStatus, setIfscVerificationStatus] = useState("");
  const [gstVerificationStatus, setGstVerificationStatus] = useState("");
  const [panVerificationStatus, setPanVerificationStatus] = useState("");
  const [accountVerificationStatus, setAccountVerificationStatus] =
    useState("");
  const [upiVerificationStatus, setUPIVerificationStatus] = useState("");
  const [subIfscVerification, setSubIfscVerification] = useState(false);
  const [ifscCode, setIfscCode] = useState("");
  const [pan, setPan] = useState("");
  const [gst, setGst] = useState("");
  const [loaders, setLoaders] = useState({});
  const [activeGroupIndex, setActiveGroupIndex] = useState(0);
  const [activeQuestionGroupIndex, setActiveQuestionGroupIndex] =
    useState(null);
  const [outletGroupDetails, setOutletGroupDetails] = useState([]);
  const [questionGroupImages, setQuestionGroupImages] = useState([]);
  const [eSignature, setEsignature] = useState([]);
  const [isLoading, setLoader] = useState(true);
  const [isGroupDetailsLoaded, setIsGroupDetailsLoaded] = useState(false);
  const [requestInProcess, setRequestInProcess] = useState(false);
  const [outletGroupDetailsCopy, setOutletGroupDetailsCopy] = useState([]);
  const [errorDetails, setErrorDetails] = useState({});
  const [validationChoices, setValidationChoices] = useState({});
  const [isSliderComplete, setIsSliderComplete] = useState(false);
  const [isInvoiceDigitizationComplete, setIsInvoiceDigitizationComplete] = useState(false);

  const handleCollectedBillsComplete = (isComplete) => {
    setIsSliderComplete(isComplete);
    const qGroups = question_groups || outletDetails?.question_groups || [];
    const currentCollectedIndex = qGroups.findIndex(
      (g) => g.name === "Collected Bills"
    );
    const targetIndex = currentCollectedIndex !== -1 ? currentCollectedIndex : activeGroupIndex;

    if (isComplete) {
      if (setSaveClickedData) {
        setSaveClickedData((prev) => ({
          ...(prev || saveClickedData || {}),
          [targetIndex]: true,
        }));
      }
      const nextIndex =
        currentCollectedIndex !== -1 && currentCollectedIndex < qGroups.length - 1
          ? currentCollectedIndex + 1
          : qGroups.findIndex((g) => g.name === "Invoice Digitization");

      if (nextIndex !== -1) {
        setActiveGroupIndex(nextIndex);
        setActiveQuestionGroupIndex({
          group_index: qGroups[nextIndex]?.id,
          position_index: nextIndex,
        });
        if (sliderRef.current && sliderRef.current.slickGoTo) {
          sliderRef.current.slickGoTo(nextIndex);
        }
      }
    } else {
      if (setSaveClickedData) {
        setSaveClickedData((prev) => {
          const updated = { ...(prev || saveClickedData || {}) };
          delete updated[targetIndex];
          return updated;
        });
      }
    }
  };

  const handleInvoiceDigitizationComplete = (isComplete) => {
    setIsInvoiceDigitizationComplete(isComplete);
    const qGroups = question_groups || outletDetails?.question_groups || [];
    const currentInvoiceIndex = qGroups.findIndex(
      (g) => g.name === "Invoice Digitization"
    );
    const targetIndex = currentInvoiceIndex !== -1 ? currentInvoiceIndex : activeGroupIndex;

    if (isComplete) {
      if (setSaveClickedData) {
        setSaveClickedData((prev) => ({
          ...(prev || saveClickedData || {}),
          [targetIndex]: true,
        }));
      }
      if (currentInvoiceIndex !== -1 && currentInvoiceIndex < qGroups.length - 1) {
        const nextIndex = currentInvoiceIndex + 1;
        setActiveGroupIndex(nextIndex);
        setActiveQuestionGroupIndex({
          group_index: qGroups[nextIndex]?.id,
          position_index: nextIndex,
        });
        if (sliderRef.current && sliderRef.current.slickGoTo) {
          sliderRef.current.slickGoTo(nextIndex);
        }
      }
    } else {
      if (setSaveClickedData) {
        setSaveClickedData((prev) => {
          const updated = { ...(prev || saveClickedData || {}) };
          delete updated[targetIndex];
          return updated;
        });
      }
    }
  };
  const [isGstLegalTradeFound, setIsGstLegalTradeFound] = useState(false);
  const [inputAnswerError, setInputAnswerError] = useState(false);
  const [inputAnswerErrorMessage, setInputAnswerErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [activeUploadQuestion, setActiveUploadQuestion] = useState(null);
  const [isModalUploading, setIsModalUploading] = useState(false);
  const [isFileDragging, setIsFileDragging] = useState(false);
  const [stagedFiles, setStagedFiles] = useState([]);

  const fileBrowseInputRef = useRef(null);

  const getFileValidationLimits = (question) => {
    if (!question) return { minVal: null, maxVal: null };
    const validations = question.validations || {};
    const minFileCount = validations.min_file_count ?? validations.min_images_count;
    const maxFileCount = validations.max_file_count ?? validations.max_images_count;

    return {
      minVal:
        minFileCount != null && minFileCount !== "" && !isNaN(minFileCount)
          ? Number(minFileCount)
          : null,
      maxVal:
        maxFileCount != null && maxFileCount !== "" && !isNaN(maxFileCount)
          ? Number(maxFileCount)
          : null,
    };
  };

  const handleAddFiles = (files) => {
    if (!files || files.length === 0) return;
    const { maxVal } = getFileValidationLimits(activeUploadQuestion);
    const currentAnswer =
      outletGroupDetails[activeUploadQuestion?.questionIndex]?.related_answers?.[0]
        ?.single_input || "";
    const existingCount =
      typeof currentAnswer === "string" && currentAnswer.trim()
        ? currentAnswer.split(",").filter(Boolean).length
        : 0;
    const stagedCount = stagedFiles.filter(
      (f) =>
        f.questionId ===
        (activeUploadQuestion && activeUploadQuestion.questionId)
    ).length;
    const newTotal = existingCount + stagedCount + files.length;

    if (maxVal !== null && maxVal > 0 && newTotal > maxVal) {
      triggerNotification({
        messageText: `Cannot add more files. Maximum allowed limit is ${maxVal} file(s).`,
        status: "FAILED",
      });
      return;
    }

    const newStaged = Array.from(files).map((file) => ({
      questionId: activeUploadQuestion && activeUploadQuestion.questionId,
      file: file,
      name: file.name,
    }));
    setStagedFiles((prev) => prev.concat(newStaged));
  };

  const handleUploadFiles = () => {
    const filesToUpload = stagedFiles.filter(
      (f) => f.questionId === (activeUploadQuestion && activeUploadQuestion.questionId)
    );
    if (filesToUpload.length === 0) return;

    setIsModalUploading(true);

    let uploadedUrls = [];
    let fileIds = [];

    const uploadSingle = (index) => {
      if (index >= filesToUpload.length) {
        const currentAnswer = outletGroupDetails[activeUploadQuestion.questionIndex]?.related_answers?.[0]?.single_input || "";
        const existingAnswers = typeof currentAnswer === "string" && currentAnswer ? currentAnswer.split(",") : [];
        const allUrls = existingAnswers.concat(uploadedUrls).filter(Boolean);

        const mockEvent = {
          target: {
            name: activeUploadQuestion.answerKey,
            value: allUrls.join(","),
          },
        };

        const wObjId = outletDetails?.related_workflow_object?.id || outletDetails?.workflow_object;

        if (fileIds.length > 0 && wObjId && activeUploadQuestion?.questionId) {
          const linkPayload = {
            data: [
              {
                question_id: activeUploadQuestion.questionId,
                workflow_object_id: wObjId,
                file_ids: fileIds,
              }
            ]
          };

          triggerSimpleAjax(
            UPLOAD_DOCUMENT_FILE_API,
            "POST",
            linkPayload,
            (linkResponse) => {
              onChange({
                e: mockEvent,
                questionIndex: activeUploadQuestion.questionIndex,
                type: "upload_file",
              });

              setStagedFiles((prev) =>
                prev.filter((f) => f.questionId !== (activeUploadQuestion && activeUploadQuestion.questionId))
              );

              setIsModalUploading(false);
              setShowFileModal(false);

              triggerNotification({
                messageText: "All files uploaded and linked successfully!",
                status: "SUCCESS",
              });
            },
            (linkError) => {
              triggerNotification({
                messageText: `Linking failed: ${linkError?.message || "Unknown error"}`,
                status: "FAILED",
              });
              setIsModalUploading(false);
            }
          );
        } else {
          onChange({
            e: mockEvent,
            questionIndex: activeUploadQuestion.questionIndex,
            type: "upload_file",
          });

          setStagedFiles((prev) =>
            prev.filter((f) => f.questionId !== (activeUploadQuestion && activeUploadQuestion.questionId))
          );

          setIsModalUploading(false);
          setShowFileModal(false);

          triggerNotification({
            messageText: "All files uploaded successfully!",
            status: "SUCCESS",
          });
        }
        return;
      }

      const pf = filesToUpload[index];
      const formData = new FormData();
      formData.append("file", pf.file);
      formData.append("name", pf.name);

      triggerSimpleAjax(
        FILE_UPLOAD_API,
        "POST",
        formData,
        (response) => {
          const fileUrl = response.image || response.file || response.url || response.id;
          if (fileUrl) {
            uploadedUrls.push(fileUrl);
          }
          if (response.id) {
            fileIds.push(response.id);
          }
          uploadSingle(index + 1);
        },
        (error) => {
          setIsModalUploading(false);
          triggerNotification({
            messageText: `Upload failed for ${pf.name}: ${error.message || "Unknown error"}`,
            status: "FAILED",
          });
        },
        {},
        true
      );
    };

    uploadSingle(0);
  };

  const handleImmediateUpload = (e, questionIndex, answerKey, questionId, question) => {
    const inputTarget = e?.target;
    const files = Array.from(inputTarget?.files || []);
    if (files.length === 0) return;

    const allowedExtensions = ["doc", "docx", "pdf"];
    const invalidFiles = files.filter((file) => {
      const ext = file.name.split(".").pop().toLowerCase();
      return !allowedExtensions.includes(ext);
    });

    if (invalidFiles.length > 0) {
      triggerNotification({
        messageText: "Invalid file type",
        status: "FAILED",
      });
      if (inputTarget) inputTarget.value = "";
      return;
    }

    const { maxVal } = getFileValidationLimits(question);
    const currentAnswer =
      outletGroupDetails[questionIndex]?.related_answers?.[0]?.single_input ||
      "";
    const existingAnswers =
      typeof currentAnswer === "string" && currentAnswer.trim()
        ? currentAnswer.split(",").filter(Boolean)
        : [];
    const totalCount = existingAnswers.length + files.length;

    if (maxVal !== null && maxVal > 0 && totalCount > maxVal) {
      triggerNotification({
        messageText: `Cannot upload. "${question?.name || "Question"
          }" allows a maximum of ${maxVal} file(s). You already have ${existingAnswers.length
          } file(s) uploaded.`,
        status: "FAILED",
      });
      if (inputTarget) inputTarget.value = "";
      return;
    }

    setLoader(true);
    let uploadedCount = 0;
    const urls = [];

    const uploadFile = (file) => {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("name", file.name);

      triggerSimpleAjax(
        FILE_UPLOAD_API,
        "POST",
        formData,
        (response) => {
          let fileUrl = response.image || response.file || response.url || response.id;
          if (fileUrl) {
            if (response.id) {
              fileUrl = `${fileUrl}#id=${response.id}`;
            }
            urls.push(fileUrl);
          }
          uploadedCount++;
          if (uploadedCount === files.length) {
            // All uploads completed
            const allUrls = existingAnswers.concat(urls).filter(Boolean);
            const newAnswerText = allUrls.join(",");

            const mockEvent = {
              target: {
                name: answerKey,
                value: newAnswerText,
              },
            };

            onChange({
              e: mockEvent,
              questionIndex: questionIndex,
              type: "upload_file",
            });
            setLoader(false);
            if (inputTarget) inputTarget.value = "";
          } else {
            uploadFile(files[uploadedCount]);
          }
        },
        (error) => {
          setLoader(false);
          if (inputTarget) inputTarget.value = "";
          triggerNotification({
            messageText: error?.message && error.message !== "Unknown error" ? error.message : "Invalid file type",
            status: "FAILED",
          });
        },
        {},
        true
      );
    };

    uploadFile(files[0]);
  };

  const fetchSurveyFiles = (outletId) => {
    const targetOutletId = outletId || outletDetails?.id;
    if (!targetOutletId) return;

    triggerSimpleAjax(
      `${FILE_UPLOAD_API}?related_multiple_files_answer_input__workflow_object__outlet=${targetOutletId}&all_survey_files=True`,
      "GET",
      {},
      (filesResponse) => {
        const itemsList = Array.isArray(filesResponse) ? filesResponse : (filesResponse?.results || []);
        const questionFiles = {};

        itemsList.forEach((item) => {
          if (item) {
            if (Array.isArray(item.files)) {
              item.files.forEach((f) => {
                const qId = f.question_id || f.question;
                if (qId) {
                  const qIdNumber = typeof qId === "object" ? qId.id : qId;
                  if (!questionFiles[qIdNumber]) {
                    questionFiles[qIdNumber] = [];
                  }
                  const fileUrlWithId = `${f.file}#id=${f.id}`;
                  questionFiles[qIdNumber].push(fileUrlWithId);
                }
              });
            } else {
              const qId = item.question_id || item.question || item.related_multiple_files_answer_input?.question;
              if (qId) {
                const qIdNumber = typeof qId === "object" ? qId.id : qId;
                if (!questionFiles[qIdNumber]) {
                  questionFiles[qIdNumber] = [];
                }
                const fileUrlWithId = `${item.file}#id=${item.id}`;
                questionFiles[qIdNumber].push(fileUrlWithId);
              }
            }
          }
        });

        setOutletGroupDetails((prevDetails) => {
          if (!Array.isArray(prevDetails)) return prevDetails;
          return prevDetails.map((q) => {
            const qId = q.id;
            if (questionFiles[qId]) {
              const singleInputVal = questionFiles[qId].join(",");
              const updatedAnswers = Array.isArray(q.related_answers) && q.related_answers.length > 0
                ? [{ ...q.related_answers[0], single_input: singleInputVal }]
                : [{ single_input: singleInputVal }];
              return {
                ...q,
                related_answers: updatedAnswers,
              };
            }
            return q;
          });
        });
      },
      (filesError) => {
        console.error("Failed to load survey files:", filesError);
      }
    );
  };

  const handleSurveyApiSubmit = (questionId, answerText, question) => {
    const { minVal } = getFileValidationLimits(question);
    const urls = (answerText || "").split(",").filter(Boolean);

    if (minVal !== null && minVal > 0 && urls.length < minVal) {
      triggerNotification({
        messageText: `Minimum ${minVal} file(s) required for "${question?.name || "this question"
          }". Currently uploaded: ${urls.length}.`,
        status: "FAILED",
      });
      return;
    }

    const fileIds = urls.map((url) => {
      const hashMatch = url.match(/#id=(\d+)/);
      if (hashMatch) return parseInt(hashMatch[1]);
      const pathMatch = url.match(/\/(\d+)(?:\/|$)/);
      return pathMatch ? parseInt(pathMatch[1]) : null;
    }).filter(Boolean);

    const wObjId = outletDetails?.related_workflow_object?.id || outletDetails?.workflow_object;

    const payloadItem = {
      question_id: questionId,
      file_ids: fileIds,
    };
    if (wObjId) {
      payloadItem.workflow_object_id = wObjId;
    }

    const linkPayload = {
      data: [payloadItem]
    };

    setLoader(true);
    triggerSimpleAjax(
      UPLOAD_DOCUMENT_FILE_API,
      "POST",
      linkPayload,
      (linkResponse) => {
        setLoader(false);
        triggerNotification({
          messageText: "Document files uploaded successfully!",
          status: "SUCCESS",
        });
        fetchSurveyFiles(outletDetails?.id);
      },
      (linkError) => {
        setLoader(false);
        triggerNotification({
          messageText: `Upload failed: ${linkError?.message || "Internal server error"}`,
          status: "FAILED",
        });
      }
    );
  };

  const onFileDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(true);
  };

  const onFileDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(false);
  };

  const onFileDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsFileDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleAddFiles(e.dataTransfer.files);
    }
  };

  const handleFileBrowseClick = () => {
    if (fileBrowseInputRef.current) {
      fileBrowseInputRef.current.click();
    }
  };


  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success"); // or 'error'
  const [selectedValidationChoice, setSelectedValidationChoice] =
    useState(null);
  const [hasPendingRequests, setHasPendingRequests] = useState(false);
  const [initDate, setinitDate] = useState("");

  const currentUser = useSelector((state) => state.user?.user_details);
  const assigned_qc_executive = outletDetails?.related_workflow_object?.assigned_qc_executive;
  const isQCAssignedToSomeoneElse = Boolean(
    assigned_qc_executive &&
    currentUser &&
    assigned_qc_executive.id !== currentUser.id &&
    assigned_qc_executive.username !== currentUser.username
  );

  const isSkuGroup =
    Array.isArray(outletDetails.question_groups) &&
    outletDetails.question_groups.length !== 0 &&
    outletDetails.question_groups[activeGroupIndex].type === "sku_group";
  const workflowId = (outletDetails.related_workflow_object || {}).id;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const project = sub_project.project;

  useEffect(() => {
    if (outletDetails?.id && activeQuestionGroupIndex) {
      fetchSurveyFiles(outletDetails.id);
    }
  }, [outletDetails, activeQuestionGroupIndex]);
  const openModal = () => {
    setIsModalOpen(true);
  };

  const onCancel = () => {
    setIsModalOpen(false);
  };

  const getCurrentSlug = (index) => {
    const data =
      outletDetails.question_groups && outletDetails.question_groups[index];
    return data?.slug;
  };
  const getGroupDetails = (index) => {
    const workflowId =
      outletDetails?.related_workflow_object?.id ||
      outletDetails?.workflow_object ||
      (typeof outletDetails?.related_workflow_object === "number" || typeof outletDetails?.related_workflow_object === "string"
        ? outletDetails.related_workflow_object
        : undefined);
    const data =
      outletDetails?.question_groups && outletDetails.question_groups[index];
    if (data) {
      if (data.name === "Collected Bills" || data.name === "Invoice Digitization" || !data.slug) {
        setLoader(false);
        setIsGroupDetailsLoaded(true);
        setOutletGroupDetails({});
        return;
      }
      setLoader(true);
      setIsGroupDetailsLoaded(false);
      const req = {
        workflow_object: outletDetails?.workflow_object || workflowId,
        question_group: data.id,
      };

      getOutletGroupDetails(req).then((res) => {
        if (!res?.results || res.results.length === 0) {
          if (setSaveClickedData) {
            setSaveClickedData((prev) => ({
              ...(prev || saveClickedData || {}),
              [index]: true,
            }));
          }
        }
        if (workflowId && data?.slug) {
          triggerSimpleAjax(
            `${GET_OUTLET_GROUP}${data.slug}/answer-linked-images/?related_multiple_images_answer_input__workflow_object=${workflowId}&related_single_image_answer_input__workflow_object=${workflowId}`,
            "GET",
            {},
            (response) => {
              const rawImages = Array.isArray(response)
                ? response
                : Array.isArray(response?.results)
                  ? response.results
                  : [];
              // Math.random is added to prevent image load from cache
              const images = rawImages
                .filter((item) => item?.id !== undefined && item?.image)
                .map(
                  (imageDetails) => `${imageDetails.image}?${Math.random()}`,
                );

              setQuestionGroupImages(images);
            },
            (error) => {
              setQuestionGroupImages([]);
            },
          );
        } else {
          setQuestionGroupImages([]);
        }

        // Initialize account_number questions with proper structure if needed
        const normalizedResults = res.results.map((q) => {
          if (
            q.type === "account_number" &&
            (!Array.isArray(q.related_answers) ||
              q.related_answers.length === 0)
          ) {
            return {
              ...q,
              related_answers: [
                {
                  single_input: "",
                  other_ifsc_code: "",
                  verified: false,
                  verified_secondary: false,
                  other_branch_name: "",
                  other_bank_name: "",
                  other_phone_number: "",
                  other_account_holder_name: "",
                  is_edited: false,
                },
              ],
            };
          }
          return q;
        });

        if (outletDetails?.id) {
          triggerSimpleAjax(
            `${FILE_UPLOAD_API}?related_multiple_files_answer_input__workflow_object__outlet=${outletDetails.id}&all_survey_files=True`,
            "GET",
            {},
            (filesResponse) => {
              const itemsList = Array.isArray(filesResponse) ? filesResponse : (filesResponse?.results || []);
              if (itemsList.length > 0) {
                const questionFiles = {};
                itemsList.forEach((item) => {
                  if (item) {
                    if (Array.isArray(item.files)) {
                      item.files.forEach((f) => {
                        const qId = f.question_id || f.question;
                        if (qId) {
                          const qIdNumber = typeof qId === "object" ? qId.id : qId;
                          if (!questionFiles[qIdNumber]) {
                            questionFiles[qIdNumber] = [];
                          }
                          const fileUrlWithId = `${f.file}#id=${f.id}`;
                          questionFiles[qIdNumber].push(fileUrlWithId);
                        }
                      });
                    } else {
                      const qId = item.question_id || item.question || item.related_multiple_files_answer_input?.question;
                      if (qId) {
                        const qIdNumber = typeof qId === "object" ? qId.id : qId;
                        if (!questionFiles[qIdNumber]) {
                          questionFiles[qIdNumber] = [];
                        }
                        const fileUrlWithId = `${item.file}#id=${item.id}`;
                        questionFiles[qIdNumber].push(fileUrlWithId);
                      }
                    }
                  }
                });

                normalizedResults.forEach((q) => {
                  const qId = q.id;
                  if (questionFiles[qId]) {
                    const singleInputVal = questionFiles[qId].join(",");
                    if (Array.isArray(q.related_answers) && q.related_answers.length > 0) {
                      q.related_answers[0].single_input = singleInputVal;
                    } else {
                      q.related_answers = [{ single_input: singleInputVal }];
                    }
                  }
                });
              }
              setOutletGroupDetails(normalizedResults);
              setOutletGroupDetailsCopy(_cloneDeep(normalizedResults));
              setLoader(false);
              setIsGroupDetailsLoaded(true);
            },
            (filesError) => {
              console.error("Failed to load survey files:", filesError);
              setOutletGroupDetails(normalizedResults);
              setOutletGroupDetailsCopy(_cloneDeep(normalizedResults));
              setLoader(false);
              setIsGroupDetailsLoaded(true);
            }
          );
        } else {
          setOutletGroupDetails(normalizedResults);
          setOutletGroupDetailsCopy(_cloneDeep(normalizedResults));
          setLoader(false);
          setIsGroupDetailsLoaded(true);
        }
      }).catch((err) => {
        console.error("Error in getOutletGroupDetails:", err);
        setLoader(false);
        setIsGroupDetailsLoaded(true);
      });
    } else {
      setLoader(false);
      setIsGroupDetailsLoaded(true);
      setOutletGroupDetails({});
    }

  };

  useEffect(() => {
    const fetchRetailerRequests = async () => {
      try {
        const response = await getRetailerRequests(workflowId);
        // Check for any pending requests
        const hasPending = response.some(
          (req) => req.retailer_master_status === "pending",
        );
        setHasPendingRequests(hasPending);
      } catch (error) {
      }
    };

    fetchRetailerRequests();
  }, []);

  const getGroupDetailsWrapper = (activeGroup) => {
    if (activeGroup && question_and_answers?.[activeGroup.group_index]) {
      getGroupDetailsBasedOnId(activeGroup);
    } else {
      getGroupDetails(activeGroupIndex);
    }
  };
  const getGroupDetailsBasedOnId = (activeGroup) => {
    if (activeGroup) {
      setLoader(true);
      setIsGroupDetailsLoaded(false);

      // Get the cached data from question_and_answers
      const cachedData = question_and_answers[activeGroup.group_index];

      // Initialize account_number questions with proper structure if needed, but preserve existing data
      const normalizedData = cachedData.map((q) => {
        if (
          q.type === "account_number" &&
          (!Array.isArray(q.related_answers) || q.related_answers.length === 0)
        ) {
          return {
            ...q,
            related_answers: [
              {
                single_input: "",
                other_ifsc_code: "",
                verified: false,
                verified_secondary: false,
                other_branch_name: "",
                other_bank_name: "",
                other_phone_number: "",
                other_account_holder_name: "",
                is_edited: false,
              },
            ],
          };
        }
        // Return the question as-is if it already has data (preserves verified bank details)
        return q;
      });

      setOutletGroupDetails(Object.assign([], normalizedData));

      const data =
        outletDetails?.question_groups &&
        outletDetails.question_groups[activeGroup?.position_index];

      if (data?.name === "Collected Bills" || data?.name === "Invoice Digitization" || !data?.slug) {
        setLoader(false);
        setIsGroupDetailsLoaded(true);
        return;
      }

      const workflowId =
        outletDetails?.related_workflow_object?.id ||
        outletDetails?.workflow_object ||
        (typeof outletDetails?.related_workflow_object === "number" || typeof outletDetails?.related_workflow_object === "string"
          ? outletDetails.related_workflow_object
          : undefined);

      if (workflowId && data?.slug) {
        triggerSimpleAjax(
          `${GET_OUTLET_GROUP}${data.slug}/answer-linked-images/?related_multiple_images_answer_input__workflow_object=${workflowId}&related_single_image_answer_input__workflow_object=${workflowId}`,
          "GET",
          {},
          (response) => {
            const rawImages = Array.isArray(response)
              ? response
              : Array.isArray(response?.results)
                ? response.results
                : [];
            const images = rawImages
              .filter((item) => item?.id !== undefined && item?.image)
              .map(
                (imageDetails) => `${imageDetails.image}?${Math.random()}`,
              );

            setQuestionGroupImages(images);
          },
          (error) => {
            setQuestionGroupImages([]);
          },
        );
      } else {
        setQuestionGroupImages([]);
      }

      setLoader(false);
      setIsGroupDetailsLoaded(true);
    }
  };

  useEffect(() => {
    if (question_and_answers != null) {
      Object.keys(question_and_answers).forEach(key => {
        question_and_answers[key].forEach(item => {
          if (item.type === "account_number" && item.related_answers.length === 0) {
            item.related_answers = [
              {
                single_input: "",
                other_ifsc_code: "",
                verified: false,
                verified_secondary: false,
                other_branch_name: "",
                other_bank_name: "",
                other_phone_number: "",
                other_account_holder_name: "",
                is_edited: false,
              }
            ];
          }
        });
      });
    }

    if (question_groups && Array.isArray(question_groups)) {
      setActiveQuestionGroupIndex({
        group_index: question_groups[0]?.id,
        position_index: 0,
      });
    }
  }, []);

  useEffect(() => {
    if (activeQuestionGroupIndex) {
      setLoader(true);
      setIsGroupDetailsLoaded(false);

      getGroupDetailsWrapper(activeQuestionGroupIndex);

      setIfscVerificationStatus(
        outletDetails?.related_workflow_object?.ifsc_code_verification_status || "",
      );
      setGstVerificationStatus(outletDetails?.gst_number_verification_status || "");
      setPanVerificationStatus(outletDetails?.pan_number_verification_status || "");
    }
  }, [activeQuestionGroupIndex]);

  useEffect(() => {
    const pos =
      activeQuestionGroupIndex?.position_index !== undefined
        ? activeQuestionGroupIndex.position_index
        : activeGroupIndex;
    if (
      typeof pos === "number" &&
      sliderRef.current &&
      typeof sliderRef.current.slickGoTo === "function"
    ) {
      sliderRef.current.slickGoTo(pos);
    }
  }, [activeQuestionGroupIndex, activeGroupIndex]);

  const isQuestionGroupOnState = (questionIndex) => {
    return question_and_answers?.[activeQuestionGroupIndex?.group_index]?.[
      questionIndex
    ];
  };

  const ensureQuestionGroupStructure = (questionIndex) => {
    const groupIndex = activeQuestionGroupIndex?.group_index;
    if (!question_and_answers[groupIndex]) return;

    if (
      !Array.isArray(
        question_and_answers[groupIndex][questionIndex]["related_answers"],
      )
    ) {
      question_and_answers[groupIndex][questionIndex]["related_answers"] = [{}];
    } else if (
      !question_and_answers[groupIndex][questionIndex]["related_answers"][0]
    ) {
      question_and_answers[groupIndex][questionIndex]["related_answers"][0] =
        {};
    }
  };

  const onChange = ({ e, questionIndex, type }) => {


    if (!outletGroupDetails[questionIndex]) return;

    // Ensure related_answers[0] exists
    if (!Array.isArray(outletGroupDetails[questionIndex]["related_answers"])) {
      outletGroupDetails[questionIndex]["related_answers"] = [{}];
    } else if (!outletGroupDetails[questionIndex]["related_answers"][0]) {
      outletGroupDetails[questionIndex]["related_answers"][0] = {};
    }

    const relatedAnswer =
      outletGroupDetails[questionIndex]["related_answers"][0];

    if (
      enableEditAnswers &&
      (type === "yes_or_no" || type === "single_choice" || type === "dropdown")
    ) {
      const selectedValue = e && e.value !== undefined && e.value !== "" ? e.value : null;
      relatedAnswer["single_input"] = selectedValue;

      if (isQuestionGroupOnState(questionIndex)) {
        ensureQuestionGroupStructure(questionIndex);
        question_and_answers[activeQuestionGroupIndex?.group_index][
          questionIndex
        ]["related_answers"][0]["single_input"] = selectedValue;
      }
    } else if (enableEditAnswers && type === "multiple_choice") {
      const multiple_array = e ? e.map((item) => item.value) : [];
      relatedAnswer["multiple_answers_input"] = multiple_array;

      if (isQuestionGroupOnState(questionIndex)) {
        ensureQuestionGroupStructure(questionIndex);
        question_and_answers[activeQuestionGroupIndex?.group_index][
          questionIndex
        ]["related_answers"][0]["multiple_answers_input"] = multiple_array;
      }
    } else {
      relatedAnswer[e.target.name] = e.target.value;

      if (isQuestionGroupOnState(questionIndex)) {
        ensureQuestionGroupStructure(questionIndex);
        question_and_answers[activeQuestionGroupIndex?.group_index][
          questionIndex
        ]["related_answers"][0][e.target.name] = e.target.value;
      }

      if (type === "census_network") {
        relatedAnswer["location_hierarchy"] = e.target.location_hierarchy || null;
        if (isQuestionGroupOnState(questionIndex)) {
          ensureQuestionGroupStructure(questionIndex);
          question_and_answers[activeQuestionGroupIndex?.group_index][
            questionIndex
          ]["related_answers"][0]["location_hierarchy"] = e.target.location_hierarchy || null;
        }
      }
    }

    relatedAnswer.is_edited = true;
    setOutletGroupDetails([...outletGroupDetails]);
  };

  const checkValidation = (name, type = "") => {
    const checkType = (type || name || "").toLowerCase();
    if (checkType.includes("ifsc")) {
      return ifscVerificationStatus === "not_verified_yet" ? true : false;
    } else if (checkType.includes("pan")) {
      return panVerificationStatus === "not_verified_yet" ? true : false;
    } else if (checkType.includes("gst")) {
      return gstVerificationStatus === "not_verified_yet" ? true : false;
    } else if (checkType.includes("account_number") || checkType.includes("account")) {
      return accountVerificationStatus === "not_verified_yet" ? true : false;
    } else if (checkType.includes("upi")) {
      return upiVerificationStatus === "not_verified_yet";
    }
    return false;
  };

  const verifyDetails = (name, answerText, questionIndex, type = "") => {
    if (name === "IFSC-sub" || (type && type.includes("ifsc_code")) || (name && name.toLowerCase().includes("ifsc"))) {
      const code = answerText || ifscCode;
      setLoaders((prev) => ({
        ...prev,
        [name]: true,
      }));
      ifscVerficationCheck(code, name, questionIndex);
    } else if (type && type.includes("pan_number")) {
      const code = pan !== "" ? pan : answerText;
      setLoaders((prev) => ({
        ...prev,
        [name]: true,
      }));
      panAndGSTVerificationCheck("PAN", code, name, questionIndex);
    } else if (type && type.includes("gst_number")) {
      let code = gst === "" ? answerText : gst;
      setLoaders((prev) => ({
        ...prev,
        [name]: true,
      }));
      panAndGSTVerificationCheck("GST", code, name, questionIndex);
      distributorGSTNumberCheck(code);
    } else if (type === "account_number" || (type && type.includes("account_number")) || (name && name.toLowerCase().includes("account"))) {
      setLoaders((prev) => ({
        ...prev,
        [name]: true,
      }));

      yesBankAccountVerification(name, questionIndex);
    } else if ((type && (type.includes("upi_id") || type.includes("upi"))) || (name && name.toLowerCase().includes("upi"))) {
      setLoaders((prev) => ({
        ...prev,
        [name]: true,
      }));

      upiVerification(name, questionIndex);
    }
  };

  const upiVerification = (name, questionIndex) => {
    let singleInput = "";
    let otherUpiAccountName = "";
    if (questionIndex !== undefined && questionIndex !== null && questionIndex >= 0 && outletGroupDetails[questionIndex]) {
      const related_answers =
        outletGroupDetails[questionIndex]?.["related_answers"]?.[0] || {};
      singleInput = related_answers.single_input;
      otherUpiAccountName = related_answers.other_upi_account_name;
    } else if (detailsInfo && detailsInfo[name]) {
      singleInput = detailsInfo[name];
    }
    const reqBody = {
      upi_id: singleInput,
      other_upi_account_name: otherUpiAccountName,
    };

    triggerSimpleAjax(
      UPI_VERIFICATION,
      "POST",
      reqBody,
      (response) => {
        triggerNotification({
          messageText: "Validated Successfully !",
          status: "SUCCESS",
        });
        setLoaders((prev) => ({
          ...prev,
          [name]: false,
        }));
        if (questionIndex !== undefined && questionIndex !== null && questionIndex >= 0 && outletGroupDetails[questionIndex]) {
          const related_answers =
            outletGroupDetails[questionIndex]?.["related_answers"]?.[0] || {};
          const updatedAnswer = {
            ...related_answers,
            verified: response.is_success,
            other_upi_account_name: response.name,
            is_edited: true,
          };
          const newGroupDetails = [...outletGroupDetails];
          newGroupDetails[questionIndex] = {
            ...newGroupDetails[questionIndex],
            related_answers: [updatedAnswer],
          };

          if (
            question_and_answers &&
            activeQuestionGroupIndex &&
            question_and_answers[activeQuestionGroupIndex.group_index] &&
            question_and_answers[activeQuestionGroupIndex.group_index][questionIndex]
          ) {
            question_and_answers[activeQuestionGroupIndex.group_index][
              questionIndex
            ].related_answers = [
                {
                  ...(question_and_answers[activeQuestionGroupIndex.group_index][
                    questionIndex
                  ]?.related_answers?.[0] || {}),
                  verified: response.is_success,
                  other_upi_account_name: response.name,
                  is_edited: true,
                },
              ];
          }

          setOutletGroupDetails(newGroupDetails);
        }
        setUPIVerificationStatus("verified");
      },
      (error) => {
        triggerNotification({
          messageText: "Validation Failed !!",
          status: "FAILED",
        });
        setLoaders((prev) => ({
          ...prev,
          [name]: false,
        }));
      },
    );
  };
  const yesBankAccountVerification = (name, questionIndex) => {
    const related_answers =
      outletGroupDetails[questionIndex]?.["related_answers"]?.[0] || {};
    const rawPhone = related_answers?.other_phone_number || "";
    const cleanPhone = rawPhone.startsWith("+91")
      ? rawPhone
      : rawPhone
        ? `+91${rawPhone}`
        : "";

    const reqBody = {
      phone_number: cleanPhone,
      to_account_number: related_answers?.single_input,
      to_account_ifsc_code: related_answers?.other_ifsc_code,
    };

    triggerSimpleAjax(
      YES_BANK_ACCOUNT_VERIFICATION,
      "POST",
      reqBody,
      (response) => {
        triggerNotification({
          messageText: "Validated Sucessfully !!",
          status: "SUCCESS",
        });
        setLoaders((prev) => ({
          ...prev,
          [name]: false,
        }));
        const holderName =
          response.other_account_holder_name ||
          response.account_holder_name ||
          response.name ||
          "N/A";
        const updatedAnswer = {
          ...related_answers,
          verified: true,
          other_account_holder_name: holderName,
          is_edited: true,
        };

        const newGroupDetails = [...outletGroupDetails];
        newGroupDetails[questionIndex] = {
          ...newGroupDetails[questionIndex],
          related_answers: [updatedAnswer],
        };

        if (
          question_and_answers &&
          activeQuestionGroupIndex &&
          question_and_answers[activeQuestionGroupIndex.group_index] &&
          question_and_answers[activeQuestionGroupIndex.group_index][questionIndex]
        ) {
          question_and_answers[activeQuestionGroupIndex.group_index][
            questionIndex
          ].related_answers = [
              {
                ...(question_and_answers[activeQuestionGroupIndex.group_index][
                  questionIndex
                ]?.related_answers?.[0] || {}),
                verified: true,
                other_account_holder_name: holderName,
                is_edited: true,
              },
            ];
        }

        setOutletGroupDetails(newGroupDetails);
        setAccountVerificationStatus("verified");
        // ❌ DO NOT auto-save or auto-navigate here
        // onSaveAction(false, true);
      },
      (error) => {
        setLoaders((prev) => ({
          ...prev,
          [name]: false,
        }));
        // triggerNotification({
        //   messageText: JSON.stringify(error),
        //   status: "FAILED",
        // });

        setSnackbarMessage(
          typeof error === "string" ? error : JSON.stringify(error)
        );
        setSnackbarType("error");
        setOpenSnackbar(true);
      },
    );
  };
  const ifscVerficationCheck = (value, name, questionIndex) => {
    triggerSimpleAjax(
      IFSC_VERIFICATION(value),
      "GET",
      {},
      (response) => {
        triggerNotification({
          messageText: `Validated Successfully !!`,
          status: "SUCCESS",
        });
        setLoaders((prev) => ({
          ...prev,
          [name]: false,
        }));
        if (name.includes("sub") || name === "IFSC-sub") {
          const updatedAnswer = {
            ...(outletGroupDetails[questionIndex]?.related_answers?.[0] || {}),
            verified_secondary: true,
            other_ifsc_code: value,
            other_branch_name: response.branch || "N/A",
            other_bank_name: response.bank || "N/A",
            is_edited: true,
          };

          const newGroupDetails = [...outletGroupDetails];
          newGroupDetails[questionIndex] = {
            ...newGroupDetails[questionIndex],
            related_answers: [updatedAnswer],
          };

          if (
            question_and_answers &&
            activeQuestionGroupIndex &&
            question_and_answers[activeQuestionGroupIndex.group_index] &&
            question_and_answers[activeQuestionGroupIndex.group_index][questionIndex]
          ) {
            question_and_answers[activeQuestionGroupIndex.group_index][
              questionIndex
            ].related_answers = [
                {
                  ...(question_and_answers[activeQuestionGroupIndex.group_index][
                    questionIndex
                  ]?.related_answers?.[0] || {}),
                  verified_secondary: true,
                  other_ifsc_code: value,
                  other_branch_name: response.branch || "N/A",
                  other_bank_name: response.bank || "N/A",
                  is_edited: true,
                },
              ];
          }
          setSubIfscVerification(false);
          setOutletGroupDetails(newGroupDetails);
        } else {
          const updatedAnswer = {
            ...(outletGroupDetails[questionIndex]?.related_answers?.[0] || {}),
            single_input: value || outletGroupDetails[questionIndex]?.related_answers?.[0]?.single_input,
            verified: true,
            other_branch_name: response.branch || "N/A",
            other_bank_name: response.bank || "N/A",
            is_edited: true,
          };

          const newGroupDetails = [...outletGroupDetails];
          newGroupDetails[questionIndex] = {
            ...newGroupDetails[questionIndex],
            related_answers: [updatedAnswer],
          };

          if (
            question_and_answers &&
            activeQuestionGroupIndex &&
            question_and_answers[activeQuestionGroupIndex.group_index] &&
            question_and_answers[activeQuestionGroupIndex.group_index][questionIndex]
          ) {
            question_and_answers[activeQuestionGroupIndex.group_index][
              questionIndex
            ].related_answers = [
                {
                  ...(question_and_answers[activeQuestionGroupIndex.group_index][
                    questionIndex
                  ]?.related_answers?.[0] || {}),
                  single_input: value || question_and_answers[activeQuestionGroupIndex.group_index][questionIndex]?.related_answers?.[0]?.single_input,
                  verified: true,
                  other_branch_name: response.branch || "N/A",
                  other_bank_name: response.bank || "N/A",
                  is_edited: true,
                },
              ];
          }
          setIfscVerificationStatus("verified");
          setOutletGroupDetails(newGroupDetails);
        }
      },
      (error) => {
        setLoaders((prev) => ({
          ...prev,
          [name]: false,
        }));
        triggerNotification({
          messageText: `Validation Failed !!`,
          status: "FAILED",
        });

        // setSnackbarMessage( `Validation Failed !!`);
        // setSnackbarType("error");
        // setOpenSnackbar(true);
      },
    );
  };
  const panAndGSTVerificationCheck = (name, value, key, questionIndex) => {
    triggerSimpleAjax(
      PAN_AND_GST_VERIFICATION + `?input_type=${name}&input=${value}`,
      "POST",
      {},
      (response) => {
        setLoaders((prev) => ({
          ...prev,
          [key]: false,
        }));
        if (name === "PAN" && response?.error) {
          triggerNotification({
            messageText: response.error,
            status: "FAILED",
          });
          return;
        }
        triggerNotification({
          messageText: `Validated Successfully !!`,
          status: "SUCCESS",
        });
        if (name === "GST") {
          const updatedAnswer = {
            ...(outletGroupDetails[questionIndex]?.related_answers?.[0] || {}),
            verified: true,
            other_gst_trade_name: response.tradeNam || "N/A",
            other_gst_legal_name: response.lgnm || "N/A",
            other_gst_registration_status: response.dty || "N/A",
            is_edited: true,
          };
          const newGroupDetails = [...outletGroupDetails];
          newGroupDetails[questionIndex] = {
            ...newGroupDetails[questionIndex],
            related_answers: [updatedAnswer],
          };

          if (
            question_and_answers &&
            activeQuestionGroupIndex &&
            question_and_answers[activeQuestionGroupIndex.group_index] &&
            question_and_answers[activeQuestionGroupIndex.group_index][questionIndex]
          ) {
            question_and_answers[activeQuestionGroupIndex.group_index][
              questionIndex
            ].related_answers = [
                {
                  ...(question_and_answers[activeQuestionGroupIndex.group_index][
                    questionIndex
                  ]?.related_answers?.[0] || {}),
                  verified: true,
                  other_gst_trade_name: response.tradeNam || "N/A",
                  other_gst_legal_name: response.lgnm || "N/A",
                  other_gst_registration_status: response.dty || "N/A",
                  is_edited: true,
                },
              ];
          }

          setOutletGroupDetails(newGroupDetails);
          setGstVerificationStatus("verified");
          onSaveAction(false, true);
        } else if (name === "PAN") {
          const updatedAnswer = {
            ...(outletGroupDetails[questionIndex]?.related_answers?.[0] || {}),
            verified: true,
            other_pan_holder_name: response.name || "N/A",
            is_edited: true,
          };
          const newGroupDetails = [...outletGroupDetails];
          newGroupDetails[questionIndex] = {
            ...newGroupDetails[questionIndex],
            related_answers: [updatedAnswer],
          };

          if (
            question_and_answers &&
            activeQuestionGroupIndex &&
            question_and_answers[activeQuestionGroupIndex.group_index] &&
            question_and_answers[activeQuestionGroupIndex.group_index][questionIndex]
          ) {
            question_and_answers[activeQuestionGroupIndex.group_index][
              questionIndex
            ].related_answers = [
                {
                  ...(question_and_answers[activeQuestionGroupIndex.group_index][
                    questionIndex
                  ]?.related_answers?.[0] || {}),
                  verified: true,
                  other_pan_holder_name: response.name || "N/A",
                  is_edited: true,
                },
              ];
          }

          setOutletGroupDetails(newGroupDetails);
          setPanVerificationStatus("verified");
          // onSaveAction(false, true)
        }
      },
      (error) => {
        setLoaders((prev) => ({
          ...prev,
          [key]: false,
        }));
        triggerNotification({
          messageText: `Validation Failed !!`,
          status: "FAILED",
        });

      },
    );
  };

  const distributorGSTNumberCheck = (value) => {
    {
      triggerSimpleAjax(
        CHECK_DISTRIBUTOR_GST +
        `?gst_number=${value}` +
        `&project_id=${project}`,
        "GET",
        {},
        (response) => {
          if (
            response?.is_gst_legal_name_found === true ||
            response?.is_gst_trade_name_found === true
          ) {
            setIsGstLegalTradeFound(true);
          }
        },
      );
    }
  };

  useEffect(() => {
    if (inputAnswerError) {
      setShowErrorPopup(true);
    }

    setTimeout(() => { }, 100);
  }, [inputAnswerErrorMessage, showErrorPopup, inputAnswerError]);

  const validateMinLengthForFields = (questionGroupDetails = []) => {
    let isValid = true;
    const errorMessages = [];

    if (!Array.isArray(questionGroupDetails)) {
      return {
        isValid: true,
        errorMessage: "",
      };
    }

    questionGroupDetails.forEach((question) => {
      const val_question_name = question?.name;
      const val_min_length = question?.validations?.min_length;
      const val_max_length = question?.validations?.max_length;
      const val_upper_limit = question?.validations?.upper_limit;
      const val_lower_limit = question?.validations?.lower_limit;
      const is_allow_decimal = question?.validations?.allow_decimals;
      const single_input_length =
        question?.related_answers?.[0]?.single_input?.length;
      const val_other_phone_number =
        question?.related_answers?.[0]?.other_phone_number;
      const val_other_ifsc_code =
        question?.related_answers?.[0]?.other_ifsc_code;
      const isRel = (val) => isRelativeDateValidation(val);

      const isRelative =
        isRel(question?.validations?.greater_than) ||
        isRel(question?.validations?.lower_than) ||
        question?.validations?.before != null ||
        question?.validations?.after != null;

      const beforeDays = isRelative
        ? (question?.validations?.greater_than ?? question?.validations?.before)
        : null;
      const afterDays = isRelative
        ? (question?.validations?.lower_than ?? question?.validations?.after)
        : null;
      const lowerThan = !isRelative ? question?.validations?.lower_than : null;
      const greaterThan = !isRelative ? question?.validations?.greater_than : null;
      const inputDate = question?.related_answers?.[0]?.single_input;

      const single_input_phone_number =
        question?.related_answers?.[0]?.single_input || "";
      //     const single_input_phone_number = question?.related_answers?.[0]?.single_input || "";
      question.hasError = false;
      question.errorMessage = "";

      if (question.type === "date") {
        if (!inputDate && question.is_mandatory) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `${val_question_name} is required!`;
          errorMessages.push(question.errorMessage);
        } else if (inputDate) {
          const valMoment = moment(
            inputDate,
            ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", "DD/MM/YYYY", moment.ISO_8601],
            true
          );
          const validMoment = valMoment.isValid() ? valMoment : moment(inputDate);

          if (!validMoment.isValid()) {
            isValid = false;
            question.hasError = true;
            question.errorMessage = `${val_question_name} must be a valid date!`;
            errorMessages.push(question.errorMessage);
          } else if (isRelative) {
            const today = moment().startOf("day");
            const minDate =
              beforeDays != null && beforeDays !== ""
                ? moment(today).subtract(Number(beforeDays), "days").startOf("day")
                : null;
            const maxDate =
              afterDays != null && afterDays !== ""
                ? moment(today).add(Number(afterDays), "days").endOf("day")
                : null;

            if (minDate && validMoment.isBefore(minDate, "day")) {
              isValid = false;
              question.hasError = true;
              question.errorMessage = `${val_question_name} cannot be older than ${beforeDays} days before today!`;
              errorMessages.push(question.errorMessage);
            } else if (maxDate && validMoment.isAfter(maxDate, "day")) {
              isValid = false;
              question.hasError = true;
              question.errorMessage = `${val_question_name} cannot be beyond ${afterDays} days after today!`;
              errorMessages.push(question.errorMessage);
            }
          } else {
            const minDate = greaterThan
              ? moment(greaterThan, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", "DD/MM/YYYY", moment.ISO_8601]).startOf("day")
              : null;
            const maxDate = lowerThan
              ? moment(lowerThan, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", "DD/MM/YYYY", moment.ISO_8601]).endOf("day")
              : null;

            if (minDate && maxDate && (validMoment.isBefore(minDate, "day") || validMoment.isAfter(maxDate, "day"))) {
              isValid = false;
              question.hasError = true;
              question.errorMessage = `${val_question_name} must be between ${greaterThan} and ${lowerThan}!`;
              errorMessages.push(question.errorMessage);
            } else if (minDate && validMoment.isBefore(minDate, "day")) {
              isValid = false;
              question.hasError = true;
              question.errorMessage = `${val_question_name} must be on or after ${greaterThan}!`;
              errorMessages.push(question.errorMessage);
            } else if (maxDate && validMoment.isAfter(maxDate, "day")) {
              isValid = false;
              question.hasError = true;
              question.errorMessage = `${val_question_name} must be on or before ${lowerThan}!`;
              errorMessages.push(question.errorMessage);
            }
          }
        }
      }

      // Validate each field type
      if (
        question.type === "text" &&
        single_input_length > 0 &&
        (single_input_length < val_min_length ||
          single_input_length > val_max_length)
      ) {
        isValid = false;
        question.hasError = true;
        question.errorMessage = `${val_question_name} must have text between ${val_min_length} to ${val_max_length}!`;
        errorMessages.push(question.errorMessage);
      }

      if (
        question.type === "number" &&
        single_input_length > 0 &&
        (single_input_length < val_min_length ||
          single_input_length > val_max_length)
      ) {
        isValid = false;
        question.hasError = true;
        question.errorMessage = `${val_question_name} must have number between ${val_lower_limit} to ${val_upper_limit}!`;
        errorMessages.push(question.errorMessage);
      }

      if (question.type === "retailer_phone_number") {
        let rawInput = single_input_phone_number || "";
        rawInput = rawInput.replace(/\s+/g, "").trim();
        if (rawInput.startsWith("+91")) {
          rawInput = rawInput.substring(3);
        }
        const digitsOnly = rawInput.replace(/\D/g, "");
        if (digitsOnly.length !== 10 && digitsOnly.length > 0) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `${val_question_name} must be exactly 10 digits! `;
          errorMessages.push(question.errorMessage);
        }
      }

      if (question.type === "auditor_contact_number") {
        let rawInput = single_input_phone_number || "";
        rawInput = rawInput.replace(/\s+/g, "").trim();
        if (rawInput.startsWith("+91")) {
          rawInput = rawInput.substring(3);
        }
        const digitsOnly = rawInput.replace(/\D/g, "");
        if (digitsOnly.length !== 10 && digitsOnly.length > 0) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `${val_question_name} must be exactly 10 digits! `;
          errorMessages.push(question.errorMessage);
        }
      }

      if (
        question.type === "pin_code" &&
        single_input_length > 0 &&
        single_input_length !== 6
      ) {
        isValid = false;
        question.hasError = true;
        question.errorMessage = "Pincode must be exactly 6 digits! ";
        errorMessages.push(question.errorMessage);
      }

      if (question.type === "phone_number") {
        let rawInput = single_input_phone_number || "";

        rawInput = rawInput.replace(/\s+/g, "").trim();

        if (rawInput.startsWith("+91")) {
          rawInput = rawInput.substring(3);
        }

        const digitsOnly = rawInput.replace(/\D/g, "");

        if (digitsOnly.length !== 10 && digitsOnly.length > 0) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `${val_question_name} must be exactly 10 digits! `;
          errorMessages.push(question.errorMessage);
        }
      }

      if (question.type === "phone_number_without_otp") {
        let rawInput = single_input_phone_number || "";

        rawInput = rawInput.replace(/\s+/g, "").trim();

        if (rawInput.startsWith("+91")) {
          rawInput = rawInput.substring(3);
        }

        const digitsOnly = rawInput.replace(/\D/g, "");

        if (digitsOnly.length !== 10 && digitsOnly.length > 0) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `${val_question_name} must be exactly 10 digits! `;
          errorMessages.push(question.errorMessage);
        }
      }

      if (question.type === "phone_number_with_otp") {
        let rawInput = single_input_phone_number || "";

        // Remove all spaces and trim
        rawInput = rawInput.replace(/\s+/g, "").trim();

        // Remove '+91' if it exists at the start
        if (rawInput.startsWith("+91")) {
          rawInput = rawInput.substring(3);
        }

        // Remove all non-digit characters
        const digitsOnly = rawInput.replace(/\D/g, "");

        if (digitsOnly.length !== 10 && digitsOnly.length > 0) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `${val_question_name} must be exactly 10 digits! `;
          errorMessages.push(question.errorMessage);
        }
      }

      if (question.type === "account_number") {
        if (
          (single_input_length < 9 || single_input_length > 18) &&
          single_input_length > 0
        ) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `${val_question_name} must be between 9 and 18 digits! `;
          errorMessages.push(question.errorMessage);
        }

        if (
          val_other_phone_number &&
          val_other_phone_number.length !== 13 &&
          val_other_phone_number.length > 0
        ) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `Phone Number must be exactly 13 digits with country code +91! `;
          errorMessages.push(question.errorMessage);
        }

        if (
          val_other_ifsc_code &&
          val_other_ifsc_code.length !== 11 &&
          val_other_ifsc_code.length > 0
        ) {
          isValid = false;
          question.hasError = true;
          question.errorMessage = `IFSC Code must be exactly 11 characters! `;
          errorMessages.push(question.errorMessage);
        }
      }

      if (
        question.type === "ifsc_code" &&
        single_input_length !== 11 &&
        single_input_length > 0
      ) {
        isValid = false;
        question.hasError = true;
        question.errorMessage = `${val_question_name} must be exactly 11 characters! `;
        errorMessages.push(question.errorMessage);
      }

      if (
        question.type === "gst_number" &&
        single_input_length !== 15 &&
        single_input_length > 0
      ) {
        isValid = false;
        question.hasError = true;
        question.errorMessage = `${val_question_name} must be exactly 15 characters! `;
        errorMessages.push(question.errorMessage);
      }

      if (
        question.type === "pan_number" &&
        single_input_length !== 10 &&
        single_input_length > 0
      ) {
        isValid = false;
        question.hasError = true;
        question.errorMessage = `${val_question_name} must be exactly 10 characters! `;
        errorMessages.push(question.errorMessage);
      }

      if (question.type === "upload_file") {
        const currentAnswer =
          question?.related_answers?.[0]?.single_input || "";
        const fileList =
          typeof currentAnswer === "string" && currentAnswer.trim()
            ? currentAnswer.split(",").filter(Boolean)
            : [];
        const fileCount = fileList.length;

        const { minVal, maxVal } = getFileValidationLimits(question);

        if (minVal !== null && minVal > 0) {
          if (question?.is_mandatory || fileCount > 0) {
            if (fileCount < minVal) {
              isValid = false;
              question.hasError = true;
              question.errorMessage = `${val_question_name} requires minimum ${minVal} file(s)!`;
              errorMessages.push(question.errorMessage);
            }
          }
        }

        if (maxVal !== null && maxVal > 0) {
          if (fileCount > maxVal) {
            isValid = false;
            question.hasError = true;
            question.errorMessage = `${val_question_name} allows maximum ${maxVal} file(s)!`;
            errorMessages.push(question.errorMessage);
          }
        }
      }


      // Push main field error message (for all types except account_number extras)
      // if (question.hasError && question.errorMessage) {
      //   errorMessages.push(question.errorMessage);
      // }
    });

    return {
      isValid,
      errorMessage: errorMessages.join("\n"),
    };
  };

  const onSaveAction = (
    sku_request_body = false,
    isBackgroundRequest = false,
  ) => {
    // const { match, workflow_permission } = props;
    // const { outlet } = match.params;

    if (!Array.isArray(outletGroupDetails) || !outletGroupDetails.length) {
      if (!isBackgroundRequest) {
        setSaveClickedData((prev) => ({
          ...(prev || saveClickedData || {}),
          [activeGroupIndex]: true,
        }));

        if (activeGroupIndex < (question_groups || []).length - 1) {
          const nextIndex = activeGroupIndex + 1;
          setActiveGroupIndex(nextIndex);
          const nextQGroup = question_groups[nextIndex];
          setActiveQuestionGroupIndex({
            group_index: nextQGroup?.id,
            position_index: nextIndex,
          });
          if (sliderRef?.current?.slickGoTo) {
            const targetSlide = Math.max(0, Math.min(nextIndex, (question_groups || []).length - 4));
            sliderRef.current.slickGoTo(targetSlide);
          }
        }
      }
      return;
    }

    const { isValid, errorMessage } =
      validateMinLengthForFields(outletGroupDetails);
    if (!isValid && errorMessage) {
      setOutletGroupDetails([...outletGroupDetails]);
      triggerNotification({
        messageText: errorMessage,
        status: "FAILED",
      });
      return;
    }

    if (isValid) {
      outletQuestionGroupSaveAction({
        outletGroupDetails: outletGroupDetails,
        setRequestInProcess,
        setSaveClickedData,
        activeGroupIndex,
        saveClickedData,
        question_groups,
        outletDetails,
        setOutletGroupDetails,
        setOutletGroupDetailsCopy,
        setActiveGroupIndex,
        setValidationChoices,
        setActiveQuestionGroupIndex,
        setErrorDetails: setErrors,
        sku_request_body,
        isBackgroundRequest,
        question_and_answers,
        activeQuestionGroupIndex,
        triggerNotificationFn: triggerNotification,
      });
    } else {
      setInputAnswerError(true);
      setInputAnswerErrorMessage(errorMessage);
      setShowErrorPopup(true);
      return;
    }
  };

  // Slick Slider Settings

  const NextArrowWrapper = () => (
    <NextArrow
      title={`Next Group (${getShortcutLabel("NEXT_GROUP")})`}
      onClick={() => {
        if (sliderRef.current && sliderRef.current.slickNext) {
          sliderRef.current.slickNext();
        }
        if (
          activeQuestionGroupIndex?.position_index <
          question_groups.length - 1
        ) {
          const nextQGroup = question_groups[activeGroupIndex + 1];
          setActiveGroupIndex(activeGroupIndex + 1);
          setActiveQuestionGroupIndex({
            group_index: nextQGroup.id,
            position_index: activeGroupIndex + 1,
          });
        }
      }}
    >
      <ArrowForwardIosIcon />
    </NextArrow>
  );
  const PrevArrowWrapper = () => (
    <PrevArrow
      title={`Previous Group (${getShortcutLabel("PREV_GROUP")})`}
      onClick={() => {
        if (sliderRef.current && sliderRef.current.slickPrev) {
          sliderRef.current.slickPrev();
        }
        if (activeQuestionGroupIndex?.position_index !== 0) {
          const nextQGroup = question_groups[activeGroupIndex - 1];
          setActiveGroupIndex(activeGroupIndex - 1);
          setActiveQuestionGroupIndex({
            group_index: nextQGroup.id,
            position_index: activeGroupIndex - 1,
          });
        }
      }}
    >
      <ArrowBackIosIcon />
    </PrevArrow>
  );

  const detailsInfo =
    outletDetails?.related_workflow_object?.other_config &&
      Object.keys(outletDetails.related_workflow_object.other_config).length > 0 &&
      outletDetails.related_workflow_object.other_config.data_to_update
      ? JSON.parse(
        outletDetails.related_workflow_object.other_config.data_to_update,
      )
      : {};

  useEffect(() => {
    const isAccountQuestion = (q) => {
      const t = (q?.type || q?.question_type || "").toLowerCase();
      const n = (q?.name || "").toLowerCase();
      return t === "account_number" || t.includes("account_number") || n.includes("account");
    };

    const isIfscQuestion = (q) => {
      const t = (q?.type || q?.question_type || "").toLowerCase();
      const n = (q?.name || "").toLowerCase();
      return (t.includes("ifsc_code") && t !== "account_number") || (n.includes("ifsc") && !n.includes("account"));
    };

    const isGstQuestion = (q) => {
      const t = (q?.type || q?.question_type || "").toLowerCase();
      const n = (q?.name || "").toLowerCase();
      return t.includes("gst_number") || n.includes("gst");
    };

    const isPanQuestion = (q) => {
      const t = (q?.type || q?.question_type || "").toLowerCase();
      const n = (q?.name || "").toLowerCase();
      return t.includes("pan_number") || n.includes("pan");
    };

    const isUpiQuestion = (q) => {
      const t = (q?.type || q?.question_type || "").toLowerCase();
      const n = (q?.name || "").toLowerCase();
      return t.includes("upi") || n.includes("upi");
    };

    const handleVerifyAccount = () => {
      if (!Array.isArray(outletGroupDetails)) return;
      const activeEl = document.activeElement;
      const accountIndex = outletGroupDetails.findIndex(isAccountQuestion);

      if (accountIndex !== -1) {
        const q = outletGroupDetails[accountIndex];
        const related = q?.related_answers?.[0];
        const isFocusedOnAccount = activeEl?.closest?.(`[data-question-index="${accountIndex}"]`);
        const subField = activeEl?.getAttribute?.("name") || activeEl?.closest?.("[data-sub-field]")?.getAttribute?.("data-sub-field");

        if (isFocusedOnAccount && activeEl && typeof activeEl.value === "string") {
          if (subField === "other_phone_number" && related) {
            related.other_phone_number = activeEl.value.trim();
          } else if (subField === "other_ifsc_code" && related) {
            related.other_ifsc_code = activeEl.value.trim();
          }
        }

        const typedVal = (isFocusedOnAccount && (!subField || subField === "single_input" || subField === q?.name) && typeof activeEl.value === "string")
          ? activeEl.value.trim()
          : "";
        const ansText = (typedVal || related?.single_input || related?.answer_text || q?.answer || "").trim();
        if (related && ansText) {
          related.single_input = ansText;
        }
        verifyDetails(q?.name || "Account Number", ansText, accountIndex, q?.type || "account_number");
      } else if (detailsInfo) {
        const accEntry = Object.entries(detailsInfo).find(([k]) => {
          const lk = k.toLowerCase().replace(/[^a-z0-9]/g, "");
          return lk.includes("account") && !lk.includes("holder");
        });
        if (accEntry && accEntry[1]) {
          verifyDetails(accEntry[0], accEntry[1]);
        }
      }
    };

    const handleVerifyIfsc = (preferAccountSub = false) => {
      if (!Array.isArray(outletGroupDetails)) return;
      const activeEl = document.activeElement;
      const subField = activeEl?.getAttribute?.("name") || activeEl?.closest?.("[data-sub-field]")?.getAttribute?.("data-sub-field");
      const isFocusedOnSubIfsc = subField === "other_ifsc_code" || activeEl?.name === "other_ifsc_code";

      const accountIndex = outletGroupDetails.findIndex(isAccountQuestion);
      const standaloneIfscIndex = outletGroupDetails.findIndex(isIfscQuestion);

      const isFocusedOnAccount = accountIndex !== -1 && activeEl?.closest?.(`[data-question-index="${accountIndex}"]`);
      const isFocusedOnStandalone = standaloneIfscIndex !== -1 && activeEl?.closest?.(`[data-question-index="${standaloneIfscIndex}"]`);

      // If user pressed Alt + V, A, I (preferAccountSub) OR is focused on account question/sub-field:
      if ((preferAccountSub || isFocusedOnAccount || isFocusedOnSubIfsc) && accountIndex !== -1) {
        const q = outletGroupDetails[accountIndex];
        const related = q?.related_answers?.[0];
        const typedVal = (isFocusedOnSubIfsc && activeEl && typeof activeEl.value === "string")
          ? activeEl.value.trim()
          : "";
        const subCode = (typedVal || related?.other_ifsc_code || "").trim();
        if (related && typedVal) {
          related.other_ifsc_code = typedVal;
        }
        verifyDetails("IFSC-sub", subCode, accountIndex, "ifsc_code");
        return;
      }

      if (isFocusedOnStandalone || (standaloneIfscIndex !== -1 && !isFocusedOnAccount && !isFocusedOnSubIfsc)) {
        const q = outletGroupDetails[standaloneIfscIndex];
        const related = q?.related_answers?.[0];
        const typedVal = (isFocusedOnStandalone && activeEl && typeof activeEl.value === "string")
          ? activeEl.value.trim()
          : "";
        const code = (typedVal || ifscCode || related?.single_input || related?.answer_text || q?.answer || "").trim();
        if (code) {
          setIfscCode(code);
        }
        verifyDetails(q?.name || "IFSC", code, standaloneIfscIndex, q?.type || "ifsc_code");
        return;
      }

      if (accountIndex !== -1) {
        const q = outletGroupDetails[accountIndex];
        const related = q?.related_answers?.[0];
        const typedVal = (isFocusedOnSubIfsc && activeEl && typeof activeEl.value === "string")
          ? activeEl.value.trim()
          : "";
        const subCode = (typedVal || related?.other_ifsc_code || "").trim();
        if (related && typedVal) {
          related.other_ifsc_code = typedVal;
        }
        verifyDetails("IFSC-sub", subCode, accountIndex, "ifsc_code");
        return;
      }

      if (standaloneIfscIndex !== -1) {
        const q = outletGroupDetails[standaloneIfscIndex];
        const related = q?.related_answers?.[0];
        const code = (ifscCode || related?.single_input || related?.answer_text || q?.answer || "").trim();
        verifyDetails(q?.name || "IFSC", code, standaloneIfscIndex, q?.type || "ifsc_code");
        return;
      }

      if (detailsInfo) {
        const ifscEntry = Object.entries(detailsInfo).find(([k]) => {
          const lk = k.toLowerCase().replace(/[^a-z0-9]/g, "");
          return lk.includes("ifsc");
        });
        if (ifscEntry && ifscEntry[1]) {
          verifyDetails(ifscEntry[0], ifscEntry[1]);
        }
      }
    };

    const handleVerifyGst = () => {
      if (!Array.isArray(outletGroupDetails)) return;
      const activeEl = document.activeElement;
      const gstIndex = outletGroupDetails.findIndex(isGstQuestion);

      if (gstIndex !== -1) {
        const q = outletGroupDetails[gstIndex];
        const related = q?.related_answers?.[0];
        const isFocused = activeEl?.closest?.(`[data-question-index="${gstIndex}"]`);
        const typedVal = (isFocused && activeEl && typeof activeEl.value === "string")
          ? activeEl.value.trim()
          : "";
        const code = (typedVal || gst || related?.single_input || related?.answer_text || q?.answer || "").trim();
        if (code) {
          setGst(code);
        }
        verifyDetails(q?.name || "GST", code, gstIndex, q?.type || "gst_number");
      } else if (detailsInfo) {
        const gstEntry = Object.entries(detailsInfo).find(([k]) => {
          const lk = k.toLowerCase().replace(/[^a-z0-9]/g, "");
          return lk.includes("gst");
        });
        if (gstEntry && gstEntry[1]) {
          verifyDetails(gstEntry[0], gstEntry[1]);
        }
      }
    };

    const handleVerifyPan = () => {
      if (!Array.isArray(outletGroupDetails)) return;
      const activeEl = document.activeElement;
      const panIndex = outletGroupDetails.findIndex(isPanQuestion);

      if (panIndex !== -1) {
        const q = outletGroupDetails[panIndex];
        const related = q?.related_answers?.[0];
        const isFocused = activeEl?.closest?.(`[data-question-index="${panIndex}"]`);
        const typedVal = (isFocused && activeEl && typeof activeEl.value === "string")
          ? activeEl.value.trim()
          : "";
        const code = (typedVal || pan || related?.single_input || related?.answer_text || q?.answer || "").trim();
        if (code) {
          setPan(code);
        }
        verifyDetails(q?.name || "PAN", code, panIndex, q?.type || "pan_number");
      } else if (detailsInfo) {
        const panEntry = Object.entries(detailsInfo).find(([k]) => {
          const lk = k.toLowerCase().replace(/[^a-z0-9]/g, "");
          return lk.includes("pan") && !lk.includes("holder");
        });
        if (panEntry && panEntry[1]) {
          verifyDetails(panEntry[0], panEntry[1]);
        }
      }
    };

    const handleVerifyUpi = () => {
      if (!Array.isArray(outletGroupDetails)) return;
      const activeEl = document.activeElement;
      const upiIndex = outletGroupDetails.findIndex(isUpiQuestion);

      if (upiIndex !== -1) {
        const q = outletGroupDetails[upiIndex];
        const related = q?.related_answers?.[0];
        const isFocused = activeEl?.closest?.(`[data-question-index="${upiIndex}"]`);
        const typedVal = (isFocused && activeEl && typeof activeEl.value === "string")
          ? activeEl.value.trim()
          : "";
        const code = (typedVal || related?.single_input || related?.answer_text || q?.answer || "").trim();
        if (related) {
          if (typedVal) {
            related.single_input = typedVal;
          } else if (!related.single_input && code) {
            related.single_input = code;
          }
        }
        verifyDetails(q?.name || "UPI", code, upiIndex, q?.type || "upi_id");
      } else if (detailsInfo) {
        const upiEntry = Object.entries(detailsInfo).find(([k]) => {
          const lk = k.toLowerCase().replace(/[^a-z0-9]/g, "");
          return lk.includes("upi");
        });
        if (upiEntry && upiEntry[1]) {
          verifyDetails(upiEntry[0], upiEntry[1]);
        }
      }
    };

    const handleVerifyDefault = () => {
      if (!Array.isArray(outletGroupDetails)) return;
      const activeEl = document.activeElement;
      const qContainer = activeEl?.closest?.("[data-question-index]");
      const formRow = activeEl?.closest?.(".form-row-container");

      let focusedIndex = -1;
      if (qContainer) {
        const rawIdx = qContainer.getAttribute("data-question-index");
        if (rawIdx !== null && rawIdx !== undefined && rawIdx !== "") {
          focusedIndex = parseInt(rawIdx, 10);
        }
      }
      if (focusedIndex === -1 && formRow) {
        const rawIdx = formRow.getAttribute("data-question-index");
        if (rawIdx !== null && rawIdx !== undefined && rawIdx !== "") {
          focusedIndex = parseInt(rawIdx, 10);
        } else {
          const rowLabel = formRow.querySelector(".form-row-label")?.textContent?.replace(/\*/g, "")?.trim()?.toLowerCase();
          if (rowLabel) {
            focusedIndex = outletGroupDetails.findIndex(
              (q) => q?.name?.trim()?.toLowerCase() === rowLabel
            );
          }
        }
      }

      const isSubField = qContainer?.getAttribute("data-is-sub-field") === "true" ||
        formRow?.getAttribute("data-sub-field") === "other_ifsc_code" ||
        formRow?.getAttribute("data-sub-field") === "other_phone_number" ||
        activeEl?.name === "other_ifsc_code" ||
        activeEl?.name === "other_phone_number";

      if (isSubField && (qContainer?.getAttribute("data-sub-field") === "other_ifsc_code" || activeEl?.name === "other_ifsc_code")) {
        const parentIndex = focusedIndex !== -1 ? focusedIndex : outletGroupDetails.findIndex((q) => {
          const t = q?.type || q?.question_type || "";
          return t === "account_number";
        });
        if (parentIndex !== -1) {
          const subCode = (activeEl && typeof activeEl.value === "string" ? activeEl.value.trim() : "") ||
            outletGroupDetails[parentIndex]?.related_answers?.[0]?.other_ifsc_code || "";
          verifyDetails("IFSC-sub", subCode, parentIndex, "ifsc_code");
          return;
        }
      }

      if (isSubField && (qContainer?.getAttribute("data-sub-field") === "other_phone_number" || activeEl?.name === "other_phone_number")) {
        const parentIndex = focusedIndex !== -1 ? focusedIndex : outletGroupDetails.findIndex((q) => {
          const t = q?.type || q?.question_type || "";
          return t === "account_number";
        });
        if (parentIndex !== -1) {
          const q = outletGroupDetails[parentIndex];
          const ansText = q?.related_answers?.[0]?.single_input || "";
          verifyDetails(q?.name || "Account Number", ansText, parentIndex, "account_number");
          return;
        }
      }

      const isQuestionVerifiable = (q) => {
        const type = q?.type || q?.question_type || "";
        return Boolean(
          type && (
            type.includes("gst_number") ||
            type.includes("pan_number") ||
            type.includes("ifsc_code") ||
            type.includes("account_number") ||
            type.includes("upi_id")
          )
        );
      };

      let targetIndex = -1;
      if (focusedIndex >= 0 && focusedIndex < outletGroupDetails.length) {
        const focusedQ = outletGroupDetails[focusedIndex];
        if (isQuestionVerifiable(focusedQ)) {
          targetIndex = focusedIndex;
        }
      }

      if (targetIndex === -1) {
        for (let i = 0; i < outletGroupDetails.length; i++) {
          const q = outletGroupDetails[i];
          const related = q?.related_answers?.[0];
          const ansText = related?.single_input || related?.answer_text || q?.answer || "";
          if (isQuestionVerifiable(q) && related && !related.verified && ansText && String(ansText).trim() !== "") {
            targetIndex = i;
            break;
          }
        }
      }

      if (targetIndex !== -1) {
        const q = outletGroupDetails[targetIndex];
        const related = q?.related_answers?.[0];
        const type = q?.type || q?.question_type || "";
        const name = q?.name || "";
        const typedVal = (targetIndex === focusedIndex && activeEl && typeof activeEl.value === "string")
          ? activeEl.value.trim()
          : "";
        const ansText = typedVal || related?.single_input || related?.answer_text || q?.answer || "";
        if (ansText && String(ansText).trim() !== "") {
          const cleanText = String(ansText).trim();
          if (type.includes("pan_number")) {
            setPan(cleanText);
          } else if (type.includes("gst_number")) {
            setGst(cleanText);
          } else if (type.includes("ifsc_code")) {
            setIfscCode(cleanText);
          }
          if (related && typedVal) {
            related.single_input = cleanText;
          }
          verifyDetails(name, cleanText, targetIndex, type);
        }
      }
    };

    const chordManager = createVerificationChordManager({
      onVerifyAccount: handleVerifyAccount,
      onVerifyIfsc: handleVerifyIfsc,
      onVerifyGst: handleVerifyGst,
      onVerifyPan: handleVerifyPan,
      onVerifyUpi: handleVerifyUpi,
      onVerifyDefault: handleVerifyDefault,
    });

    const handleKeyDown = (e) => {
      // Prevent shortcut execution if any modal or viewer is open
      if (isAnyModalOpen()) {
        return;
      }

      const currentGroupName = question_groups?.[activeGroupIndex]?.name || outletDetails?.question_groups?.[activeGroupIndex]?.name;
      const isBillsOrDigitization = currentGroupName === "Collected Bills" || currentGroupName === "Invoice Digitization";

      if (!isBillsOrDigitization && chordManager.handleKeyDown(e)) {
        return;
      }

      if (isNextGroupShortcut(e)) {
        e.preventDefault();
        e.stopPropagation();
        if (
          Array.isArray(question_groups) &&
          activeGroupIndex < question_groups.length - 1
        ) {
          const nextIndex = activeGroupIndex + 1;
          const nextQGroup = question_groups[nextIndex];
          setActiveGroupIndex(nextIndex);
          setActiveQuestionGroupIndex({
            group_index: nextQGroup?.id,
            position_index: nextIndex,
          });
          if (sliderRef.current && sliderRef.current.slickGoTo) {
            sliderRef.current.slickGoTo(nextIndex);
          }
        }
      } else if (isPrevGroupShortcut(e)) {
        e.preventDefault();
        e.stopPropagation();
        if (Array.isArray(question_groups) && activeGroupIndex > 0) {
          const prevIndex = activeGroupIndex - 1;
          const prevQGroup = question_groups[prevIndex];
          setActiveGroupIndex(prevIndex);
          setActiveQuestionGroupIndex({
            group_index: prevQGroup?.id,
            position_index: prevIndex,
          });
          if (sliderRef.current && sliderRef.current.slickGoTo) {
            sliderRef.current.slickGoTo(prevIndex);
          }
        }
      } else if (isTotalImageShortcut(e)) {
        if (isBillsOrDigitization) {
          // Child component (CollectedBills / InvoiceDigitization) handles its own image viewer
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (outletDetails?.slug && outletDetails?.id) {
          window.open(
            DASHBOARDROUTES.GET_DASHBOARD_INDIVIDUAL_OUTLET_VIEW_TOTAL_IMAGES_NEW(
              outletDetails.slug,
              outletDetails.id,
              "total-images"
            )
          );
        }
      } else if (isSaveShortcut(e)) {
        if (isBillsOrDigitization) {
          // Child component (CollectedBills / InvoiceDigitization) handles its own validation and save
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (
          !requestInProcess &&
          !hasPendingRequests
        ) {
          onSaveAction();
        }
      } else if (isResetShortcut(e)) {
        e.preventDefault();
        e.stopPropagation();
        if (outletGroupDetailsCopy) {
          setOutletGroupDetails(_cloneDeep(outletGroupDetailsCopy));
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);
    return () => {
      chordManager.destroy();
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, [
    activeGroupIndex,
    question_groups,
    activeQuestionGroupIndex,
    outletDetails,
    requestInProcess,
    hasPendingRequests,
    outletGroupDetailsCopy,
    outletGroupDetails,
    loaders,
    gst,
    pan,
    ifscCode,
    detailsInfo,
  ]);

  const settings = {
    // variableWidth: true,
    //   centerMode: true,
    //   centerPadding: '0',
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrowWrapper />,
    prevArrow: <PrevArrowWrapper />,
  };

  const setErrors = (err) => {
    triggerNotification({
      messageText: JSON.stringify(err),
      status: "FAILED",
    });

    setErrorDetails(err);
  };

  const isShowUploadImage = (workflow_permission === WORKFLOW_KEYS.QC_EXECUTIVE || workflow_permission === WORKFLOW_KEYS.QC_MANAGER) && workflow_state == "qc_pending";



  const enableEditAnswers =
    [WORKFLOW_KEYS.QC_MANAGER, WORKFLOW_KEYS.QC_EXECUTIVE].includes(
      workflow_permission,
    ) ||
      (workflow_permission === WORKFLOW_KEYS.PROJECT_MANAGER &&
        workflow_state === "qc_accepted") ||
      workflow_state === "wip_client_accepted" ||
      workflow_state === "calling_accepted"
      ? workflow_permission === WORKFLOW_KEYS.QC_EXECUTIVE &&
        workflow_state !== "qc_pending"
        ? false
        : !workflowStateChanged
          ? isUpdateActionListAvailable || WORKFLOW_KEYS.PROJECT_MANAGER
          : false
      : false;
  // const enableEditAnswers = ([WORKFLOW_KEYS.QC_MANAGER, WORKFLOW_KEYS.QC_EXECUTIVE].includes(workflow_permission) ||
  //   (workflow_permission === WORKFLOW_KEYS.PROJECT_MANAGER && workflow_state === "qc_accepted")) ?

  //   (workflow_permission === WORKFLOW_KEYS.QC_EXECUTIVE && workflow_state !== "qc pending") ? false :
  //   (!workflowStateChanged ? (isUpdateActionListAvailable || WORKFLOW_KEYS.PROJECT_MANAGER) : false) :

  //   false;

  const retailerQuestionArray = Object.keys(detailsInfo || {}).map((key, i) => {
    if (
      outletDetails.related_workflow_object.other_config.changed_fields.includes(
        key,
      )
    ) {
      return (
        <Fragment>
          <FormRow
            leftSideWidth={"25%"}
            name={capitializeFirstChar(key).split("_").join("")}
            rightElement={
              <Fragment>
                <Container>
                  <DashboardTextBox
                    type="text"
                    boxWidth="240px"
                    boxPadding="8px 14px"
                    value={detailsInfo[key]}
                    placeholder={key}
                    fieldName={key}
                  />

                  {(key.toUpperCase().includes("IFSC") ||
                    key.toUpperCase().includes("PAN") ||
                    getIsKeyInString(key, "PAN NUMBER") ||
                    key.toUpperCase().includes("GST") ||
                    key.toUpperCase().includes("ACCOUNT") ||
                    key.toUpperCase().includes("UPI")) && (
                      <VerificationText isVerified={checkValidation(key)}>
                        {checkValidation(key) ? (
                          <Fragment>
                            <div>
                              <CloseIcon />
                              Not Verified
                            </div>
                            <div>
                              {enableEditAnswers ? (
                                <Button
                                  title={
                                    key.toUpperCase().includes("IFSC")
                                      ? `Validate IFSC (${getShortcutLabel("VALIDATE_IFSC")})`
                                      : (key.toUpperCase().includes("PAN") || getIsKeyInString(key, "PAN NUMBER"))
                                        ? `Validate PAN (${getShortcutLabel("VALIDATE_PAN")})`
                                        : (key.toUpperCase().includes("GST") || key.toUpperCase().includes("GSTIN"))
                                          ? `Validate GST (${getShortcutLabel("VALIDATE_GST")})`
                                          : key.toUpperCase().includes("ACCOUNT")
                                            ? `Validate Account (${getShortcutLabel("VALIDATE_ACCOUNT")})`
                                            : key.toUpperCase().includes("UPI")
                                              ? `Validate UPI (${getShortcutLabel("VALIDATE_UPI")})`
                                              : `Validate (${getShortcutLabel("VALIDATE")})`
                                  }
                                  size="small"
                                  isLoading={loaders[key] || false}
                                  margin="10px 0px 0px 10px"
                                  bgColor={green300}
                                  boxWidth="20px"
                                  boxHeight="30px"
                                  onClick={() =>
                                    verifyDetails(key, detailsInfo[key])
                                  }
                                >
                                  {key.toUpperCase().includes("ACCOUNT")
                                    ? "Validate Account"
                                    : key.toUpperCase().includes("IFSC")
                                      ? "Validate IFSC"
                                      : (key.toUpperCase().includes("GST") || key.toUpperCase().includes("GSTIN"))
                                        ? "Validate GST"
                                        : (key.toUpperCase().includes("PAN") || getIsKeyInString(key, "PAN NUMBER"))
                                          ? "Validate PAN"
                                          : key.toUpperCase().includes("UPI")
                                            ? "Validate UPI"
                                            : "Validate"}
                                </Button>
                              ) : (
                                ""
                              )}
                            </div>
                          </Fragment>
                        ) : (
                          <span>
                            <VerifiedUserIcon />
                            Verified
                          </span>
                        )}
                      </VerificationText>
                    )}
                </Container>
              </Fragment>
            }
          />
        </Fragment>
      );
    }
  });
  const saveButton = () => {
    if (!enableEditAnswers) return null;

    const hasQuestions =
      ((questionRowsWithoutImage?.elements || []).length || 0) +
      ((retailerQuestionArray || []).length || 0) !==
      0;

    if (!hasQuestions) return null;

    if (hasPendingRequests) {
      return (
        <p style={{ color: "red", fontWeight: "bold", marginTop: "16px" }}>
          Please complete all pending retailer edits before proceeding.
        </p>
      );
    }

    return (
      <ButtonWrapper>
        <Button
          size="small"
          margin="12px"
          changeOnlyBgColor
          color={curiousBlue300}
          bgColor={white}
          title={`Reset (${getShortcutLabel("RESET")})`}
          onClick={() =>
            setOutletGroupDetails(_cloneDeep(outletGroupDetailsCopy))
          }
        >
          Reset
        </Button>
        <Button
          size="medium"
          type="submit"
          bgColor={green300}
          isLoading={requestInProcess}
          title={`Save (${getShortcutLabel("SAVE")})`}
          onClick={requestInProcess ? null : () => onSaveAction()}
          isDisabled={isQCAssignedToSomeoneElse || is_hold}
        >
          {activeGroupIndex === question_groups.length - 1
            ? "Save"
            : "Save & Next"}
        </Button>
      </ButtonWrapper>
    );
  };


  const handleSliderComplete = (isCompleted) => {
    if (isCompleted) {
    }
    // Perform actions you want to after slider completes
  };

  const travelLog = (outletDetails.related_workflow_object || {}).travel_log
    ? outletDetails.related_workflow_object.travel_log[0]
    : "";
  const showRemarksBelowTexBox = travelLog === "calling_rejected";

  useEffect(() => {
    if (Array.isArray(outletGroupDetails)) {
      outletGroupDetails.forEach((question) => {
        const { related_answers } = question;
        const answerDetails = (related_answers || [])[0];

        if (
          answerDetails?.answer_type === "gst_number" &&
          answerDetails?.verified
        ) {
          if (
            answerDetails?.is_gst_trade_name_found === true ||
            answerDetails?.is_gst_legal_name_found === true
          ) {
            setIsGstLegalTradeFound(true);
          }
        }
      });
    }
  }, [outletGroupDetails]);

  const questionRowsWithoutImage =
    Array.isArray(outletGroupDetails) &&
    outletGroupDetails?.reduce(
      (questionArray, question, questionIndex) => {
        const {
          name,
          slug,
          reference_images,
          related_answers,
          validations,
          is_mandatory = false,
          type,
        } = question || {};
        const answerDetails = (related_answers || [])[0];
        const details = [];
        const multipleDetails = [];
        const {
          single_input,
          latitude_input,
          longitude_input,
          calculated_distance,
          answer_type,
          previous_answers = {},
          multiple_answers_input = [],
          remarks,
        } = answerDetails || {};

        if (
          type === "yes_or_no" ||
          type === "single_choice" ||
          type === "dropdown"
        ) {
          details.push({ label: "Select Option", value: null });
          const validationCondition =
            (validations?.choices && validations?.choices.split(";")) || [];
          let validationList =
            validationCondition.length > 0 &&
            validationCondition.map((item, i) => {
              details.push({ label: item, value: item });
            });
        }
        if (type === "multiple_choice") {
          const validationCondition =
            (validations?.choices && validations?.choices.split(";")) || [];
          validationCondition.map((item, i) => {
            multipleDetails.push({ label: item, value: item });
          });
        }

        if (!["multiple_image", "single_image"].includes(type)) {
          let answerText;
          let answerMultiText = [];
          let answerKey = "";
          if (type.includes("location")) {
            answerText = `${latitude_input},${longitude_input}`;
            answerKey = "latitude_input;longitude_input;calculated_distance";
          } else if (type === "multiple_choice") {
            answerMultiText = multiple_answers_input;
            answerKey = "multiple_answers_input";
          } else {
            answerText = single_input;
            answerKey = "single_input";
          }
          let additionalFields = [];
          // Extra Fields for PAN
          if (type.includes("pan_number")) {
            const isGstVerified = answerDetails?.verified === true;
            const panDetails = [
              {
                label: "Pan Holder Name",
                type: "text",
                answer: isGstVerified
                  ? answerDetails?.other_pan_holder_name
                  : "",
                field_name: "other_pan_holder_name",
              },
            ];
            additionalFields = panDetails;
          }

          // Extra Fields for GST
          if (type.includes("gst_number")) {
            // If GST is not verified, set GST Status, Legal Name, and Trade Name to empty
            const isGstVerified = answerDetails?.verified === true;
            const gstDetails = [
              {
                label: "Trade Name",
                type: "text",
                answer: isGstVerified
                  ? answerDetails?.other_gst_trade_name
                  : "",
                field_name: "other_gst_trade_name",
              },
              {
                label: "Legal Name",
                type: "text",
                answer: isGstVerified
                  ? answerDetails?.other_gst_legal_name
                  : "",
                field_name: "other_gst_legal_name",
              },
              {
                label: "GST Status",
                type: "text",
                answer: isGstVerified
                  ? answerDetails?.other_gst_registration_status
                  : "",
                field_name: "other_gst_registration_status",
              },
            ];
            additionalFields = gstDetails;
          }

          if (type.includes("upi_id")) {
            const upiDetails = [
              {
                label: "UPI Name",
                type: "text",
                answer: answerDetails?.other_upi_account_name,
                field_name: "other_upi_account_name",
              },
            ];
            additionalFields = upiDetails;
          }

          if (type.includes("ifsc_code")) {
            const isVerified = answerDetails?.verified === true;
            const ifscDetails = [
              {
                label: "Branch Name",
                type: "text",
                answer: isVerified ? answerDetails?.other_branch_name : "",
                field_name: "other_branch_name",
              },
              {
                label: "Bank Name",
                type: "text",
                answer: isVerified ? answerDetails?.other_bank_name : "",
                field_name: "other_bank_name",
              },
            ];
            additionalFields = ifscDetails;
          }
          // Extra fields for Account Number
          // if (name.toUpperCase().includes("ACCOUNT HOLDER NAME"))

          if (type == "account_number") {
            const accountDetails = [
              {
                label: "Phone Number",
                type: "account_number_phone_number",
                answer: answerDetails?.other_phone_number,
                field_name: "other_phone_number",
                disabled: !enableEditAnswers,
              },
              {
                label: "IFSC",
                type: "ifsc_code",
                answer: answerDetails?.other_ifsc_code,
                field_name: "other_ifsc_code",
                disabled: !enableEditAnswers,
                // ...(answerDetails?.verified_secondary !== undefined && {
                verification_key: "verified_secondary",
                isIFSC: true,
                // })
              },
              {
                label: "Branch Name",
                type: "text",
                answer: answerDetails?.["verified_secondary"] === true ? answerDetails?.other_branch_name : "",
                field_name: "other_branch_name",
              },
              {
                label: "Bank Name",
                type: "text",
                answer: answerDetails?.["verified_secondary"] === true ? answerDetails?.other_bank_name : "",
                field_name: "other_bank_name",
              },
              {
                label: "Account Holder Name",
                type: "text",
                answer: answerDetails?.verified === true ? answerDetails?.other_account_holder_name : "",
                field_name: "other_account_holder_name",
              },
            ];
            additionalFields = accountDetails;
          }

          const handleKeyDown = (e, name, type) => {
            if (e.key === "Enter" || e.keyCode === 13) {
              e.preventDefault();
              e.stopPropagation();
              focusNextInputField(e);
              return;
            }

            const isAlphanumeric = /^[a-zA-Z0-9]$/.test(e.key);
            const allowedKeys = [
              "Backspace",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Delete",
              "Enter",
            ];
            const isNumeric = /^[0-9+]$/.test(e.key);
            const isAllowedUpiChar = /^[a-zA-Z0-9@._-]$/.test(e.key);

            const upperName = name.toUpperCase();

            if (e.ctrlKey || e.metaKey || e.altKey) {
              return;
            } else if (
              type === "phone_number" &&
              !isNumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "retailer_phone_number" &&
              !isNumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "auditor_contact_number" &&
              !isNumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "phone_number_without_otp" &&
              !isNumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "phone_number_with_otp" &&
              !isNumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "pin_code" &&
              !isNumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "ifsc_code" &&
              !isAlphanumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "gst_number" &&
              !isAlphanumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "pan_number" &&
              !isAlphanumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "ifsc_code" &&
              !isAlphanumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "account_number" &&
              !isNumeric &&
              type != "ifsc_code" &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            } else if (
              type === "account_number_phone_number" &&
              !isNumeric &&
              !allowedKeys.includes(e.key)
            ) {
              e.preventDefault();
            }
          };

          const maxLength = (name, type) => {
            let maxLength = 10000;

            if (type === "phone_number") {
              maxLength = 13;
            }
            if (type === "retailer_phone_number") {
              maxLength = 13;
            }
            if (type === "auditor_contact_number") {
              maxLength = 13;
            }
            if (type === "phone_number_without_otp") {
              maxLength = 13;
            }
            if (type === "phone_number_with_otp") {
              maxLength = 13;
            } else if (type === "account_number_phone_number") {
              maxLength = 13;
            } else if (type === "pin_code") {
              maxLength = 6;
            } else if (type === "ifsc_code") {
              maxLength = 11;
            } else if (type === "gst_number") {
              maxLength = 15;
            } else if (type === "pan_number") {
              maxLength = 10;
            } else if (type === "ifsc_code") {
              maxLength = 11;
            } else if (type === "account_number") {
              maxLength = 18;
            }
            return maxLength;
          };

          const additionalElement = ({
            label,
            type,
            answer,
            field_name,
            disabled = true,
            isIFSC = false,
            verification_key = "",
          }) => {
            const iconColor = type === "success" ? "green" : "red";

            return (
              <FormRow
                name={label}
                type={type}
                leftSideWidth={"30%"}
                data-question-index={questionIndex}
                data-sub-field={field_name}
                rightElement={
                  <div
                    data-question-index={questionIndex}
                    data-sub-field={field_name}
                    data-is-sub-field="true"
                  >
                    <Fragment>
                      <Container>
                        <div>
                          <DashboardTextBox
                            boxWidth={
                              questionGroupImages?.length ? "240px" : "340px"
                            }
                            type={type}
                            disabled={disabled}
                            readOnly={disabled}
                            value={answer ? answer : ""} //
                            boxPadding="8px 14px"
                            background={black100}
                            placeholder={label}
                            fieldName={field_name}
                            maxLength={maxLength(name, type)}
                            onEnter={(e) => handleKeyDown(e, name, type)}
                            onChange={(e) => {
                              setSubIfscVerification(false);
                              if (verification_key) {
                                answerDetails[verification_key] = false;
                              }
                              onChange({ e, questionIndex, type });
                            }}
                          />

                          {(label === "Trade Name" || label === "Legal Name") &&
                            isGstLegalTradeFound && (
                              <div
                                className="error-icon-container"
                                style={{
                                  marginLeft: "105%",
                                  transform: "translateY(-100%)",
                                }}
                              >
                                <Error
                                  style={{ color: "red", fontSize: "200%" }}
                                  onClick={openModal}
                                />
                              </div>
                            )}
                          {isModalOpen && (
                            <Modal
                              withHeader
                              top="25%"
                              modalWidth="35%"
                              noContainerShadow={true}
                              modalHeight="40%"
                              backDropOpacity={0.3}
                              closeIconColor={black300}
                              closeAction={onCancel}
                            >
                              <div>
                                <Error
                                  style={{
                                    color: "red",
                                    fontSize: "500%",
                                    marginTop: "5%",
                                    marginLeft: "47%",
                                  }}
                                />
                                <h4
                                  style={{
                                    fontSize: "135%",
                                    marginTop: "10%",
                                    marginLeft: "25%",
                                  }}
                                >
                                  Trade name or Legal name are same!
                                </h4>
                                <Button margin={"5% 43.5%"} onClick={onCancel}>
                                  OK
                                </Button>
                              </div>
                            </Modal>
                          )}
                        </div>
                        {isIFSC && answerDetails?.other_ifsc_code && (
                          <VerificationText
                            isVerified={
                              answerDetails?.[verification_key] === true
                            }
                          >
                            {!answerDetails[verification_key] ||
                              subIfscVerification ? (
                              <div>
                                <span>
                                  <CloseIcon />
                                  Not Verified
                                </span>
                                {enableEditAnswers ? (
                                  <Button
                                    title={`Validate IFSC (${getShortcutLabel("VALIDATE_IFSC")})`}
                                    size="small"
                                    isLoading={loaders["IFSC-sub"] || false}
                                    margin="10px 0px 0px 10px"
                                    bgColor={green300}
                                    boxWidth="20px"
                                    boxHeight="30px"
                                    onClick={() => {
                                      verifyDetails(
                                        "IFSC-sub",
                                        answerDetails.other_ifsc_code,
                                        questionIndex,
                                        type,
                                      );
                                    }}
                                  >
                                    Validate IFSC
                                  </Button>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              <span>
                                <VerifiedUserIcon />
                                Verified
                              </span>
                            )}
                          </VerificationText>
                        )}
                      </Container>

                      <ConfirmationModal
                        open={openSnackbar}
                        backgroundColor={true}
                        confirmationText={snackbarMessage}
                        hideBoxShadow={true}
                        closeAction={() => setOpenSnackbar(false)}
                        headerText={
                          <WarningIcon
                            style={{ color: iconColor, fontSize: 60 }}
                          />
                        }
                      />
                    </Fragment>
                  </div>
                }
              />
            );
          };
          const questionId = answerDetails?.question;
          const image = questionGroupImages?.find((img) =>
            img.includes(questionId),
          );
          const { minVal: fileMinVal, maxVal: fileMaxVal } = getFileValidationLimits(question);

          const element = (
            <FormRow
              name={name}
              asterisk={is_mandatory}
              leftSideWidth={"30%"}
              data-question-index={questionIndex}
              data-question-name={name}
              data-question-type={type}
              rightElement={
                <div
                  data-question-index={questionIndex}
                  data-question-name={name}
                  data-question-type={type}
                >
                  {type === "census_network" ? (
                    <CensusNetworkFields
                      key={question.id}
                      width={questionGroupImages.length ? "240px" : "340px"}
                      value={answerText}
                      disabled={!enableEditAnswers}
                      locationHierarchy={answerDetails?.location_hierarchy}
                      onChange={(val, hierarchyObj) => {
                        const event = {
                          target: {
                            value: val,
                            name: answerKey,
                            location_hierarchy: hierarchyObj
                          },
                        };
                        onChange({ e: event, questionIndex, type });
                      }}
                    />) : type === "upload_file" ? (
                      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-start",
                            gap: "16px",
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            accept=".doc,.docx,.pdf"
                            disabled={!enableEditAnswers}
                            style={{ display: "none" }}
                            id={`file-input-${question.id}`}
                            onChange={(e) => handleImmediateUpload(e, questionIndex, answerKey, question.id, question)}
                          />

                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "12px" }}>
                            <button
                              type="button"
                              disabled={!enableEditAnswers}
                              onClick={() => {
                                if (enableEditAnswers) {
                                  document.getElementById(`file-input-${question.id}`).click();
                                }
                              }}
                              style={{
                                width: 96,
                                height: 96,
                                backgroundColor: "#ffffff",
                                border: "2px dashed #cfcfcf",
                                borderRadius: 6,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: enableEditAnswers ? "pointer" : "not-allowed",
                              }}
                            >
                              <div
                                style={{
                                  width: 44,
                                  height: 44,
                                  borderRadius: "50%",
                                  backgroundColor: "#d9d9d9",
                                  color: "#ffffff",
                                  fontSize: 28,
                                  fontWeight: "bold",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                +
                              </div>
                            </button>

                            <button
                              type="button"
                              disabled={!enableEditAnswers}
                              onClick={() => {
                                if (enableEditAnswers) {
                                  handleSurveyApiSubmit(question.id, answerText, question);
                                }
                              }}
                              style={{
                                padding: "10px 20px",
                                border: "none",
                                borderRadius: "6px",
                                background: green300,
                                color: "#fff",
                                fontWeight: 500,
                                cursor: enableEditAnswers ? "pointer" : "not-allowed",
                              }}
                            >
                              Upload File
                            </button>

                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "2px" }}>
                              {(fileMinVal !== null || fileMaxVal !== null) && (
                                <span style={{ fontSize: "11px", color: "#666" }}>
                                  {fileMinVal !== null ? `Min: ${fileMinVal}` : ""}
                                  {fileMinVal !== null && fileMaxVal !== null ? " | " : ""}
                                  {fileMaxVal !== null ? `Max: ${fileMaxVal}` : ""} files
                                </span>
                              )}
                              <span style={{ fontSize: "11px", color: "#666" }}>
                                doc, docx, pdf
                              </span>
                            </div>
                          </div>

                          {answerText && (
                            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px" }}>
                              {answerText.split(",").filter(Boolean).map((url, idx) => {
                                const cleanUrl = url.split("#")[0];
                                const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
                                const isPDF = /\.pdf(\?|$)/i.test(cleanUrl);
                                const isWord = /\.(doc|docx)(\?|$)/i.test(cleanUrl);
                                const isImage = /\.(jpg|jpeg|png|gif|webp)(\?|$)/i.test(cleanUrl);

                                return (
                                  <div
                                    key={idx}
                                    style={{
                                      width: 96,
                                      height: 96,
                                      overflow: "hidden",
                                      borderRadius: 6,
                                      position: "relative",
                                      border: "2px solid #cfcfcf",
                                      background: "#fff",
                                      cursor: "pointer"
                                    }}
                                  >
                                    <div
                                      onClick={() => {
                                        if (isWord) {
                                          window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(cleanUrl)}`, "_blank");
                                        } else {
                                          window.open(cleanUrl, "_blank");
                                        }
                                      }}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        overflow: "hidden"
                                      }}
                                      title={fileName}
                                    >
                                      {isPDF && (
                                        <Document file={cleanUrl}>
                                          <Page pageNumber={1} width={80} />
                                        </Document>
                                      )}
                                      {isWord && (
                                        <iframe
                                          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(cleanUrl)}`}
                                          style={{
                                            width: "480px",
                                            height: "480px",
                                            transform: "scale(0.2)",
                                            transformOrigin: "top left",
                                            border: "none",
                                            pointerEvents: "none",
                                            position: "absolute",
                                            top: 0,
                                            left: 0
                                          }}
                                          title="doc-preview"
                                        />
                                      )}
                                      {isImage && (
                                        <img
                                          src={cleanUrl}
                                          alt={fileName}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                          }}
                                        />
                                      )}
                                      {!isImage && !isPDF && !isWord && (
                                        <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#eceff1", color: "#607d8b", fontWeight: "bold", fontSize: "12px" }}>
                                          {fileName.split(".").pop().toUpperCase()}
                                        </div>
                                      )}
                                    </div>

                                    {enableEditAnswers && (
                                      <span
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const updatedUrls = answerText.split(",").filter((_, i) => i !== idx).join(",");
                                          const event = {
                                            target: {
                                              name: answerKey,
                                              value: updatedUrls
                                            }
                                          };
                                          onChange({ e: event, questionIndex, type });
                                        }}
                                        style={{
                                          position: "absolute",
                                          top: "4px",
                                          right: "4px",
                                          width: "18px",
                                          height: "18px",
                                          borderRadius: "50%",
                                          backgroundColor: "rgba(0,0,0,0.6)",
                                          color: "#fff",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          fontSize: "10px",
                                          fontWeight: "bold",
                                          cursor: "pointer",
                                          zIndex: 10
                                        }}
                                      >
                                        ✕
                                      </span>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                        {question.hasError && question.errorMessage && (
                          <div style={{ color: "#d9534f", fontSize: "12px", marginTop: "4px" }}>
                            {question.errorMessage}
                          </div>
                        )}
                      </div>
                    ) : enableEditAnswers &&
                      (type === "yes_or_no" ||
                        type === "single_choice" ||
                        type === "dropdown") ? (
                    <SelectFilter
                      props={{
                        width: questionGroupImages.length ? "240px" : "340px",
                        border: `1px solid ${black200}`,
                        placeholderColor: black700,
                        options: details,
                        fieldName: answerKey,
                        value: details.filter(
                          (condition) => (condition.value || null) === (answerText || null),
                        ),
                        onChange: (e) => {
                          onChange({ e, questionIndex, type });
                        },
                      }}
                      customStyles={{
                        borderRadius: "2px",
                        background: black200,
                      }}
                      noOptionMessage="No data available"
                    />
                  ) : type === "multiple_choice" ? (
                    <SelectFilter
                      customStyles={{
                        borderRadius: "2px",
                        background: white,
                      }}
                      props={{
                        placeholder: "Select " + name,
                        border: `1px solid ${black200}`,
                        placeholderColor: black700,
                        isDisabled: !enableEditAnswers,

                        value: multipleDetails.filter(({ value }) =>
                          multiple_answers_input
                            .map((input) => input.toLowerCase())
                            .includes(value.toLowerCase()),
                        ),
                        onChange: (e) => {
                          onChange({ e, questionIndex, type });
                        },

                        options: multipleDetails,
                        fieldName: answerKey,
                        width: questionGroupImages.length ? "240px" : "340px",
                        border: `1px solid ${black200}`,
                        isMulti: true,
                      }}
                      noOptionMessage="No data available"
                    />
                  ) : type === "e_signature" ? (
                    <div>
                      {image ? (
                        <img
                          src={image}
                          alt="E-Signature"
                          style={{
                            width: "240px",
                            height: "150px",
                            border: `1px solid ${black200}`,
                            borderRadius: "4px",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "240px",
                            height: "50px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "4px",
                            backgroundColor: "#fff5f5",
                          }}
                        >
                          Not Answered
                        </div>
                      )}
                    </div>
                  ) : (
                    <Fragment>
                      <Container>
                        <div>
                          {type === "date" ? (() => {
                            const qValidations = validations || {};
                            const isRelVal =
                              isRelativeDateValidation(qValidations?.greater_than) ||
                              isRelativeDateValidation(qValidations?.lower_than) ||
                              qValidations?.before != null ||
                              qValidations?.after != null;

                            const relBefore = isRelVal
                              ? (qValidations?.greater_than ?? qValidations?.before)
                              : null;
                            const relAfter = isRelVal
                              ? (qValidations?.lower_than ?? qValidations?.after)
                              : null;

                            const dateMin = isRelVal && relBefore != null && relBefore !== ""
                              ? moment().subtract(Number(relBefore), "days").format("YYYY-MM-DD")
                              : (!isRelVal && qValidations?.greater_than ? moment(qValidations.greater_than, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", moment.ISO_8601]).format("YYYY-MM-DD") : undefined);

                            const dateMax = isRelVal && relAfter != null && relAfter !== ""
                              ? moment().add(Number(relAfter), "days").format("YYYY-MM-DD")
                              : (!isRelVal && qValidations?.lower_than ? moment(qValidations.lower_than, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", moment.ISO_8601]).format("YYYY-MM-DD") : undefined);

                            const formattedValue = answerText
                              ? (() => {
                                const m = moment(
                                  answerText,
                                  ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", "DD/MM/YYYY", moment.ISO_8601],
                                  true
                                );
                                if (m.isValid()) return m.format("YYYY-MM-DD");
                                const loose = moment(answerText);
                                return loose.isValid() ? loose.format("YYYY-MM-DD") : "";
                              })()
                              : "";

                            return (
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                <input
                                  type="date"
                                  disabled={!enableEditAnswers}
                                  min={dateMin}
                                  max={dateMax}
                                  value={formattedValue}
                                  onChange={(e) => {
                                    const inputDate = e.target.value;
                                    const event = {
                                      target: {
                                        value: inputDate || "",
                                        name: answerKey,
                                      },
                                    };

                                    if (inputDate) {
                                      const valMoment = moment(
                                        inputDate,
                                        ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", "DD/MM/YYYY", moment.ISO_8601],
                                        true
                                      );
                                      const validMoment = valMoment.isValid() ? valMoment : moment(inputDate);

                                      if (!validMoment.isValid()) {
                                        question.hasError = true;
                                        question.errorMessage = `${name} must be a valid date!`;
                                      } else if (isRelVal) {
                                        const today = moment().startOf("day");
                                        const minD =
                                          relBefore != null && relBefore !== ""
                                            ? moment(today).subtract(Number(relBefore), "days").startOf("day")
                                            : null;
                                        const maxD =
                                          relAfter != null && relAfter !== ""
                                            ? moment(today).add(Number(relAfter), "days").endOf("day")
                                            : null;

                                        if (minD && validMoment.isBefore(minD, "day")) {
                                          question.hasError = true;
                                          question.errorMessage = `${name} cannot be older than ${relBefore} days before today!`;
                                        } else if (maxD && validMoment.isAfter(maxD, "day")) {
                                          question.hasError = true;
                                          question.errorMessage = `${name} cannot be beyond ${relAfter} days after today!`;
                                        } else {
                                          question.hasError = false;
                                          question.errorMessage = "";
                                        }
                                      } else {
                                        const gt = qValidations?.greater_than;
                                        const lt = qValidations?.lower_than;
                                        const minD = gt
                                          ? moment(gt, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", "DD/MM/YYYY", moment.ISO_8601]).startOf("day")
                                          : null;
                                        const maxD = lt
                                          ? moment(lt, ["YYYY-MM-DD", "DD-MM-YYYY", "MM/DD/YYYY", "DD/MM/YYYY", moment.ISO_8601]).endOf("day")
                                          : null;

                                        if (minD && maxD && (validMoment.isBefore(minD, "day") || validMoment.isAfter(maxD, "day"))) {
                                          question.hasError = true;
                                          question.errorMessage = `${name} must be between ${gt} and ${lt}!`;
                                        } else if (minD && validMoment.isBefore(minD, "day")) {
                                          question.hasError = true;
                                          question.errorMessage = `${name} must be on or after ${gt}!`;
                                        } else if (maxD && validMoment.isAfter(maxD, "day")) {
                                          question.hasError = true;
                                          question.errorMessage = `${name} must be on or before ${lt}!`;
                                        } else {
                                          question.hasError = false;
                                          question.errorMessage = "";
                                        }
                                      }
                                    } else {
                                      question.hasError = false;
                                      question.errorMessage = "";
                                    }

                                    onChange({ e: event, questionIndex, type });
                                  }}
                                  placeholder={name}
                                  style={{
                                    padding: "12px 10px",
                                    width: questionGroupImages.length
                                      ? "240px"
                                      : "340px",
                                    background: black100,
                                    fontSize: "15px",
                                    border: question.hasError ? "1px solid #d9534f" : "none",
                                    borderRadius: "4px",
                                    outline: "none",
                                    color: "#676262ff",
                                  }}
                                />
                                {question.hasError && question.errorMessage && (
                                  <div style={{ color: "#d9534f", fontSize: "12px", marginTop: "4px" }}>
                                    {question.errorMessage}
                                  </div>
                                )}
                              </div>
                            );
                          })() : type.includes("location") ? (
                            <div
                              style={{
                                display: "flex",
                                gap: "24px",
                                flexWrap: "nowrap",
                                alignItems: "center",
                                width: "100%",
                                minWidth: 0,
                              }}
                            >
                              <div
                                style={{
                                  flex: "0 0 auto",
                                  minWidth:
                                    questionGroupImages.length
                                      ? "240px"
                                      : "340px",
                                }}
                              >
                                <DashboardTextBox
                                  boxWidth={
                                    questionGroupImages.length
                                      ? "240px"
                                      : "340px"
                                  }
                                  boxPadding="8px 14px"
                                  type="text"
                                  disabled={!enableEditAnswers}
                                  value={answerText || ""}
                                  background={black100}
                                  placeholder="Location"
                                  fieldName={answerKey}
                                  onChange={(e) => {
                                    onChange({ e, questionIndex, type });
                                  }}
                                  warnMessage={
                                    showRemarksBelowTexBox
                                      ? {
                                        text: remarks,
                                        align: "right",
                                        onlyTextError: true,
                                      }
                                      : {}
                                  }
                                  maxLength={maxLength(name, type)}
                                  onEnter={(e) =>
                                    handleKeyDown(e, name, type)
                                  }
                                />
                              </div>

                              <div
                                style={{
                                  flex: "0 0 180px",
                                  minWidth: "180px",
                                }}
                              >
                                <DashboardTextBox
                                  boxWidth="180px"
                                  boxPadding="8px 14px"
                                  type="text"
                                  disabled={true}
                                  value={
                                    answerDetails?.calculated_distance !== undefined &&
                                      answerDetails?.calculated_distance !== null
                                      ? `${answerDetails.calculated_distance} m`
                                      : " N/A"
                                  }
                                  background="#F3F4F6"
                                  placeholder="Distance"
                                  style={{
                                    border: "1px solid #D1D5DB",
                                    borderRadius: "10px",
                                    color: "#9CA3AF",
                                    fontWeight: 500,
                                    cursor: "not-allowed",
                                  }}
                                />
                              </div>
                            </div>
                          ) : (
                            <DashboardTextBox
                              boxWidth={
                                questionGroupImages.length ? "240px" : "340px"
                              }
                              boxPadding="8px 14px"
                              type={
                                answer_type === "number" ? "number" : "text"
                              }
                              disabled={!enableEditAnswers}
                              value={
                                [
                                  "phone_number",
                                  "phone_number_without_otp",
                                  "phone_number_with_otp",
                                  "retailer_phone_number",
                                  "auditor_contact_number",
                                ].includes(type)
                                  ? typeof answerText === "string" &&
                                    answerText.includes("+91")
                                    ? answerText
                                    : `+91${answerText || ""}`
                                  : type.includes("gst_number") ||
                                    type.includes("pan_number")
                                    ? typeof answerText === "string"
                                      ? answerText.toUpperCase()
                                      : answerText || ""
                                    : answerText || ""
                              }
                              background={black100}
                              placeholder="text"
                              fieldName={answerKey}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (type.includes("ifsc_code")) {
                                  setIfscVerificationStatus("not_verified_yet");
                                  if (answerDetails)
                                    answerDetails.verified = false;
                                  setIfscCode(inputValue);
                                } else if (type.includes("pan_number")) {
                                  setPanVerificationStatus("not_verified_yet");
                                  if (answerDetails)
                                    answerDetails.verified = false;
                                  setPan(inputValue);
                                } else if (
                                  type.includes("gst_number")
                                ) {
                                  setGstVerificationStatus("not_verified_yet");
                                  if (answerDetails)
                                    answerDetails.verified = false;
                                  setGst(inputValue);
                                  setIsGstLegalTradeFound(false);
                                } else if (
                                  type.includes("BANK ACCOUNT")
                                ) {
                                  if (answerDetails)
                                    answerDetails.verified = false;
                                } else if (
                                  type.includes("account_number")
                                ) {
                                  setAccountVerificationStatus(
                                    "not_verified_yet",
                                  );
                                  if (answerDetails)
                                    answerDetails.verified = false;
                                } else if (type.includes("upi_id")) {
                                  if (answerDetails)
                                    answerDetails.verified = false;
                                }
                                onChange({ e, questionIndex, type });
                              }}
                              warnMessage={
                                showRemarksBelowTexBox
                                  ? {
                                    text: remarks,
                                    align: "right",
                                    onlyTextError: true,
                                  }
                                  : {}
                              }
                              maxLength={maxLength(name, type)}
                              onEnter={(e) => handleKeyDown(e, name, type)}
                            />
                          )}

                          {(type.includes("ifsc_code") ||
                            type.includes("pan_number") ||
                            type.includes("gst_number") ||
                            type.includes("account_number") ||
                            type.includes("upi_id")) && (
                              <VerificationText
                                isVerified={answerDetails?.verified === true}
                              >
                                {!answerDetails?.verified ? (
                                  <div>
                                    <span>
                                      <CloseIcon />
                                      Not Verified
                                    </span>
                                    {enableEditAnswers && (
                                      <Button
                                        title={
                                          (type.toLowerCase().includes("account") || name.toLowerCase().includes("account"))
                                            ? `Validate Account (${getShortcutLabel("VALIDATE_ACCOUNT")})`
                                            : (type.toLowerCase().includes("ifsc") || name.toLowerCase().includes("ifsc"))
                                              ? `Validate IFSC (${getShortcutLabel("VALIDATE_IFSC")})`
                                              : (type.toLowerCase().includes("gst") || name.toLowerCase().includes("gst"))
                                                ? `Validate GST (${getShortcutLabel("VALIDATE_GST")})`
                                                : (type.toLowerCase().includes("pan") || name.toLowerCase().includes("pan"))
                                                  ? `Validate PAN (${getShortcutLabel("VALIDATE_PAN")})`
                                                  : (type.toLowerCase().includes("upi") || name.toLowerCase().includes("upi"))
                                                    ? `Validate UPI (${getShortcutLabel("VALIDATE_UPI")})`
                                                    : `Validate (${getShortcutLabel("VALIDATE")})`
                                        }
                                        size="small"
                                        isLoading={loaders[name] || false}
                                        margin="10px 0px 0px 10px"
                                        bgColor={green300}
                                        boxWidth="20px"
                                        boxHeight="30px"
                                        onClick={() =>
                                          verifyDetails(
                                            name,
                                            answerText,
                                            questionIndex,
                                            type,
                                          )
                                        }
                                      >
                                        {(type.toLowerCase().includes("account") || name.toLowerCase().includes("account"))
                                          ? "Validate Account"
                                          : (type.toLowerCase().includes("ifsc") || name.toLowerCase().includes("ifsc"))
                                            ? "Validate IFSC"
                                            : (type.toLowerCase().includes("gst") || name.toLowerCase().includes("gst"))
                                              ? "Validate GST"
                                              : (type.toLowerCase().includes("pan") || name.toLowerCase().includes("pan"))
                                                ? "Validate PAN"
                                                : (type.toLowerCase().includes("upi") || name.toLowerCase().includes("upi"))
                                                  ? "Validate UPI"
                                                  : "Validate"}
                                      </Button>
                                    )}
                                  </div>
                                ) : (
                                  <span>
                                    <VerifiedUserIcon />
                                    Verified
                                  </span>
                                )}
                              </VerificationText>
                            )}
                        </div>
                      </Container>
                    </Fragment>
                  )}
                  {Object.keys(previous_answers).map((key) => (
                    <>
                      <TextWrapper data-tip data-for={`phoneNumber${key}`}>
                        {getDayOrNumberSuffix(key)} Prev: &nbsp;&nbsp;
                        {previous_answers[key].single_input}
                      </TextWrapper>
                      <ReactTooltip
                        id={`phoneNumber${key}`}
                        place={"bottom"}
                        type={"dark"}
                      >
                        <p>{previous_answers[key].sub_project_name}</p>
                      </ReactTooltip>
                    </>
                  ))}
                </div>
              }
            />
          );
          questionArray.elements.push(element);
          additionalFields.map((field) => {
            questionArray.elements.push(additionalElement(field));
          });
        } else {
          {
            Object.keys(previous_answers).map((key) => {
              // Init array if not already exists
              questionArray.prevWorkflowID[key] =
                previous_answers[key].workflow_object;

              if (!questionArray.prevAnsImages[key]) {
                questionArray.prevAnsImages[key] = [];
              }

              if (type === "single_image") {
                questionArray.prevAnsImages[key].push(
                  previous_answers[key].single_image_input.image,
                );
              } else {
                questionArray.prevAnsImages[key] = [
                  ...questionArray.prevAnsImages[key],
                  ...(previous_answers[key].multiple_images_input || []).map(
                    (a) => a.image,
                  ),
                ];
              }
            });
          }
        }

        return questionArray;
      },
      { elements: [], prevAnsImages: {}, prevWorkflowID: {} },
    );

  const isCurrentGroupEmpty =
    isGroupDetailsLoaded &&
    !isLoading &&
    ((questionRowsWithoutImage?.elements || []).length ||
      (retailerQuestionArray || []).length) === 0;

  const isGroupEmptyByIndex = (group, index) => {
    if (!group || group.name === "Collected Bills" || group.name === "Invoice Digitization") {
      return false;
    }
    if (index === activeGroupIndex && isCurrentGroupEmpty) {
      return true;
    }
    if (
      question_and_answers &&
      group.id &&
      question_and_answers[group.id] !== undefined &&
      Array.isArray(question_and_answers[group.id]) &&
      question_and_answers[group.id].length === 0
    ) {
      return true;
    }
    if (Array.isArray(group.questions) && group.questions.length === 0) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (isCurrentGroupEmpty && activeGroupIndex !== undefined) {
      const currentGroupName =
        question_groups?.[activeGroupIndex]?.name ||
        outletDetails?.question_groups?.[activeGroupIndex]?.name;
      if (
        currentGroupName !== "Collected Bills" &&
        currentGroupName !== "Invoice Digitization"
      ) {
        if (
          setSaveClickedData &&
          !(saveClickedData || {}).hasOwnProperty(activeGroupIndex)
        ) {
          setSaveClickedData((prev) => ({
            ...(prev || saveClickedData || {}),
            [activeGroupIndex]: true,
          }));
        }
      }
    }
  }, [
    isCurrentGroupEmpty,
    activeGroupIndex,
    question_groups,
    outletDetails,
  ]);

  useEffect(() => {
    if (question_groups && Array.isArray(question_groups)) {
      const emptyIndices = {};
      question_groups.forEach((group, idx) => {
        if (
          group.name !== "Collected Bills" &&
          group.name !== "Invoice Digitization"
        ) {
          const groupId = group.id;
          if (
            question_and_answers &&
            groupId &&
            question_and_answers[groupId] !== undefined &&
            Array.isArray(question_and_answers[groupId]) &&
            question_and_answers[groupId].length === 0
          ) {
            emptyIndices[idx] = true;
          } else if (
            Array.isArray(group.questions) &&
            group.questions.length === 0
          ) {
            emptyIndices[idx] = true;
          }
        }
      });
      if (Object.keys(emptyIndices).length > 0 && setSaveClickedData) {
        setSaveClickedData((prev) => ({
          ...(prev || saveClickedData || {}),
          ...emptyIndices,
        }));
      }
    }
  }, [question_groups, question_and_answers]);

  return (
    <Fragment>
      <Title>{sub_project.name}</Title>
      {question_groups || [].length ? (
        <VerticalNav>
          <Slider {...settings} ref={sliderRef}>
            {question_groups.map((group, index) => {
              const currentPos =
                activeQuestionGroupIndex?.position_index !== undefined
                  ? activeQuestionGroupIndex.position_index
                  : activeGroupIndex;
              return (
                <VerticalNavItem
                  key={index}
                  className={index === currentPos ? "active" : ""}
                  onClick={() => {
                    setIsGroupDetailsLoaded(false);
                    setLoader(true);
                    setActiveGroupIndex(index);
                    setActiveQuestionGroupIndex({
                      group_index: group?.id,
                      position_index: index,
                    });
                  }}
                >
                  <span>{group.name}</span>
                  {enableEditAnswers &&
                    ((
                      group.name === "Collected Bills"
                        ? isSliderComplete
                        : group.name === "Invoice Digitization"
                          ? isInvoiceDigitizationComplete
                          : (saveClickedData || {}).hasOwnProperty(index) ||
                          isGroupEmptyByIndex(group, index)
                    ) ? (
                      <i />
                    ) : null)}
                </VerticalNavItem>
              );
            })}
          </Slider>
        </VerticalNav>
      ) : null}
      {isLoading ? (
        <Loader />
      ) : (
        <ContentWrapper>
          {(question_groups?.[activeGroupIndex]?.name === "Collected Bills" ||
            outletDetails?.question_groups?.[activeGroupIndex]?.name === "Collected Bills") ? (
            <div>
              <CollectedBills
                outletDetails={outletDetails}
                history={history}
                enableEditAnswers={enableEditAnswers}
                setIsSliderComplete={handleCollectedBillsComplete}
              />
            </div>
          ) : (question_groups?.[activeGroupIndex]?.name === "Invoice Digitization" ||
            outletDetails?.question_groups?.[activeGroupIndex]?.name === "Invoice Digitization") ? (
            <div>
              <InvoiceDigitization
                outletDetails={outletDetails}
                history={history}
                enableEditAnswers={enableEditAnswers}
                workflow_permission={workflow_permission}
                setIsSliderComplete={handleInvoiceDigitizationComplete}
              />
            </div>
          ) : Array.isArray(outletDetails.question_groups) &&
            outletDetails.question_groups[activeGroupIndex]?.type &&
            isSkuGroup &&
            outletGroupDetails.length > 0 ? (
            <SkuTableOutlet
              sku_products={
                outletDetails.question_groups[activeGroupIndex]
                  .related_sku_products
              }
              outlet_group_details={outletGroupDetails}
              on_save={onSaveAction}
              saveButton={saveButton}
              disabled={!enableEditAnswers}
              requestInProcess={requestInProcess}
              workflowobject={outletDetails.workflow_object}
            />
          ) : (
            <>
              <QuestionContainer
                className="question-container"
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.keyCode === 13) {
                    if (e.target && e.target.tagName === "TEXTAREA" && !e.ctrlKey) {
                      return;
                    }
                    if (e.altKey || e.ctrlKey || e.metaKey) {
                      return;
                    }
                    if (e.target && ["INPUT", "SELECT"].includes(e.target.tagName)) {
                      e.preventDefault();
                      e.stopPropagation();
                      focusNextInputField(e);
                    }
                  }
                }}
              >
                {!isLoading && questionRowsWithoutImage?.elements}
                <p>
                  {((questionRowsWithoutImage?.elements || []).length ||
                    (retailerQuestionArray || []).length) === 0
                    ? "No Data available"
                    : ""}
                </p>
                {enableEditAnswers ? (
                  hasPendingRequests ? (
                    <p
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        marginTop: "16px",
                      }}
                    >
                      Please complete all pending retailer's request before
                      proceeding.
                    </p>
                  ) : !isCurrentGroupEmpty ? (
                    <ButtonWrapper>
                      {((questionRowsWithoutImage?.elements || []).length ||
                        (retailerQuestionArray || []).length) !== 0 && (
                          <Button
                            size="small"
                            margin="12px"
                            changeOnlyBgColor
                            color={curiousBlue300}
                            bgColor={white}
                            title={`Reset (${getShortcutLabel("RESET")})`}
                            onClick={() =>
                              setOutletGroupDetails(
                                _cloneDeep(outletGroupDetailsCopy),
                              )
                            }
                          >
                            Reset
                          </Button>
                        )}
                      <Button
                        size="medium"
                        type="submit"
                        bgColor={green300}
                        isLoading={requestInProcess}
                        title={`Save (${getShortcutLabel("SAVE")})`}
                        onClick={requestInProcess ? null : () => onSaveAction()}
                      >
                        {activeGroupIndex === question_groups.length - 1
                          ? "Save"
                          : "Save & Next"}
                      </Button>
                    </ButtonWrapper>
                  ) : null
                ) : null}
              </QuestionContainer>
            </>
          )}
          {question_groups?.[activeGroupIndex]?.name !== "Collected Bills" &&
            outletDetails?.question_groups?.[activeGroupIndex]?.name !== "Collected Bills" &&
            question_groups?.[activeGroupIndex]?.name !== "Invoice Digitization" &&
            outletDetails?.question_groups?.[activeGroupIndex]?.name !== "Invoice Digitization" && (
              <div>
                <ImageZoom
                  triggerNotification={triggerNotification}
                  showPrevSurveyImageTiles={true}
                  prevAnsImages={questionRowsWithoutImage.prevAnsImages}
                  showCurrentSurveyImageTiles={
                    !isSkuGroup && questionGroupImages.length
                  }
                  currentSurveyImages={isSkuGroup ? [] : questionGroupImages}
                  defaultActiveImage={questionGroupImages[0]}
                  totalImageCount={outletDetails.total_images_linked_to_answers}
                  totalImages={totalImages}
                  imageSectionwidth={
                    questionGroupImages.length && !isSkuGroup ? "" : "250px"
                  }
                  isSkuGroup={isSkuGroup}
                  newTab={true}
                  outlet_slug={outletDetails.slug}
                  outlet_id={outletDetails.id}
                  workflowState={outletDetails.workflow_state}
                  isShowUploadImage={isShowUploadImage}
                  workflowId={workflowId}
                  workflowSlug={getCurrentSlug(activeGroupIndex)}
                  prevWorkflowId={outletDetails?.previous_outlet?.outlet_id}
                  currentQuestionGroupDetails={outletGroupDetails}
                />
              </div>
            )}
        </ContentWrapper>
      )}

    </Fragment>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    triggerNotification: bindActionCreators(triggerNotification, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(OutletSurvey);